var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\r\n    The United States of America flag, produced by Daniel McRae\r\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-222.55-115.23H735.4v718.46h-957.95z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.67 0 0 .67 148.68 76.99)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#00319c",
    d: "M322.04 328.99H768.5v273.89H322.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#d62918",
    d: "M-256.67 329.84h445.19v273.04h-445.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#00319c",
    d: "M-255.82-115.23h445.19v305.39h-445.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#d62918",
    d: "M324.6-112.67h443.04v305.7H324.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M-256.41 190.12h1025.9v141.69h-1025.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M187.42-113.73h138.27v716.96H187.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M246.46 194.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M247.17 194.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M247.87 194.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c9c",
    d: "M252.79 194.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848ca5",
    d: "M253.97 194.5l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c9c",
    d: "M254.9 194.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M259.83 194.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M260.53 194.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M261.24 194.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M241.54 194.95l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M242.24 194.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M242.94 194.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M243.65 194.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425a84",
    d: "M244.35 194.95l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M245.52 195.17l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M246.93 195.17l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M235.73 201.47c-8.315.163-19.44.722-26.72 4.93-4.847 2.8-4.324 10.662 2.098 10.466v.67H209.7v.67l10.553-2.68v-.668h-4.22v-.67h4.923l-1.407-2.677 25.325-2.677-1.407-4.686c9.453-1.136 16.938-.302 26.03 2.01v.668l-5.63-1.34c.654 2.9 3.945 2.17 6.333 1.34l-7.034 1.34v.668l16.18 1.453 16.884 3.902v.67l-9.146-1.34v.67l11.256 3.347-2.11-2.008v-.67l2.814 3.348c4.464.185 7.817 1.192 10.552 4.685l-9.85-4.016 5.63 12.718h.703v-2.008h.702v2.008l6.33-1.34c-1.638-6.74-4.457-14.707-11.255-18.073.6-2.57-.006-3.685-2.11-5.356 2.61 5.14-1.745 7.274-5.628 3.347l-1.408 1.34 1.407-4.686-4.222 4.016.703-4.685h-.702l-.704 4.016-2.11-2.007-.704 2.008-11.256-1.338v-6.024l1.407 2.008h.705v-2.008l3.517 2.008h.704l14.07.67.703 5.354h.703l2.11-4.685c-8.132-3.426-17.9-4.513-26.733-4.686.46-4.552-4.547-5.375-8.44-5.936-6.717-.966-27.388-3.33-28.14 5.935z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M261 195.17l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M262.41 195.17l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M263.35 194.95l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M264.05 194.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M264.75 194.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M265.46 194.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M266.16 194.95l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M239.43 195.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M240.13 195.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M240.83 195.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M241.54 195.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M242.24 195.62l.703.67-.703-.67m23.215 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M266.16 195.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M266.86 195.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M267.57 195.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M268.27 195.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M237.32 196.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M238.02 196.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M238.72 196.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M239.43 196.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M246.46 196.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M247.17 196.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M247.87 196.29l.703.67-.703-.67m1.407 0l.703.67-.703-.67zm4.223 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M257.72 196.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M259.83 196.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M260.53 196.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M268.27 196.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M268.97 196.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M269.68 196.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M270.38 196.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M235.91 196.96l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M236.61 196.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M237.32 196.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M241.54 196.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M242.24 196.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M242.94 196.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M243.65 196.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M244.35 196.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M246.46 196.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M247.87 196.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M249.28 196.96l.703.67-.703-.67zm4.22 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M260.53 196.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M263.82 197.18l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M264.75 196.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M270.38 196.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M271.08 196.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M271.79 196.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "M235.91 197.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M241.54 197.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M244.35 197.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M246.46 197.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M247.87 197.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M255.61 197.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M256.31 197.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M257.01 197.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M258.42 197.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M262.64 197.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M264.75 197.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M271.79 197.62l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M272.49 197.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M235.21 198.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M241.54 198.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M242.24 198.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M243.18 198.74l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M243.88 198.74l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M245.06 198.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M247.17 198.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M248.57 198.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M255.61 198.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M256.31 198.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M257.01 198.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M258.42 198.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M259.12 198.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M262.64 198.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M264.75 198.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M273.19 198.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M234.5 198.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M235.21 198.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M241.54 198.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M245.06 198.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M245.76 198.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M247.17 198.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M247.87 198.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M248.57 198.96l.703.67-.703-.67m9.145 0l.704.67-.705-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M259.36 199.41l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M262.64 198.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M263.35 198.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M264.05 198.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M264.75 198.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M272.49 198.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M273.19 198.96l.703.67-.703-.67m-38.692.67l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M235.44 200.08l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M241.54 199.63l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M242.94 199.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M245.06 199.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M245.76 199.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M247.17 199.63l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M247.87 199.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M255.61 199.63l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M256.31 199.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M257.01 199.63l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M261.94 199.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M263.35 199.63l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M264.52 199.86l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M234.5 200.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M241.54 200.3l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M242.94 200.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M243.65 200.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M244.35 200.3l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M245.76 200.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M249.28 200.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M255.84 200.75l.235.446-.235-.446m1.173-.446l1.407 2.008-1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M259.12 200.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M261.94 200.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M264.05 200.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M231.69 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M234.5 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M235.21 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M242.94 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M245.76 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M246.46 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M247.17 200.97l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M247.87 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M248.57 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M249.28 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M259.12 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M262.64 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M264.05 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M265.46 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M272.49 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M273.19 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M276.01 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M278.82 200.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M223.25 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M223.95 201.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M225.12 201.86l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M226.06 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M226.76 201.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M227.94 201.86l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M228.87 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M242.94 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M245.76 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M246.46 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M248.57 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M249.28 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M250.68 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M251.39 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M252.09 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M254.9 201.64l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M259.12 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M259.83 201.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M261.24 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M262.64 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M264.05 201.64l.703.67-.703-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M278.82 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M280 201.86l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M280.93 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M281.64 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M282.34 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M283.04 201.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M283.75 201.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M284.45 201.64l.703.67-.703-.67m-65.425.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M219.73 202.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M220.43 202.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M221.14 202.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29396b",
    d: "M221.84 202.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M222.54 202.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M223.25 202.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M223.95 202.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M234.5 202.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M242.24 202.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M242.94 202.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M264.05 202.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M264.75 202.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M265.46 202.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M271.79 202.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M284.22 202.53l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M285.15 202.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M285.86 202.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M286.56 202.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M287.26 202.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M287.97 202.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M288.67 202.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M216.21 202.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M216.92 202.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M217.62 202.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M218.32 202.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M219.03 202.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M226.76 202.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M234.5 202.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M271.79 202.98l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M275.31 202.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M276.01 202.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M277.42 202.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M288.67 202.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M289.38 202.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M290.08 202.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M290.78 202.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M291.49 202.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M292.19 202.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M213.4 203.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M214.1 203.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M214.8 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M215.51 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M216.21 203.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M221.14 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M221.84 203.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M222.54 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M225.36 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M226.06 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M227.23 203.87l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M228.17 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M234.5 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M246.23 203.87l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M247.17 203.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M247.87 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29396b",
    d: "M248.57 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425a84",
    d: "M249.28 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M253.5 203.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#737b94",
    d: "M254.2 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29396b",
    d: "M259.12 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M260.3 203.87l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M261.7 203.87l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b4a",
    d: "M271.79 203.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M276.01 203.65l1.407 5.355-1.407-5.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M279.53 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M280.23 203.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M281.64 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M284.45 203.65l-.703 2.678.703-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M291.49 203.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M292.19 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M292.89 203.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M293.6 203.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M294.3 203.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M211.29 204.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M211.99 204.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M212.69 204.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M213.4 204.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M220.43 204.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M223.25 204.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M225.83 204.54l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M226.76 204.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M227.94 204.54l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M235.21 204.32l.703.67-.703-.67m8.442 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M244.35 204.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M261.24 204.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M261.94 204.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M262.64 204.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M263.35 204.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M264.28 204.77l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M271.08 204.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M271.79 204.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M278.12 204.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M278.82 204.32l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M279.53 204.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M281.64 204.32l1.407 1.34-1.407-1.34zm4.22 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M286.56 204.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M287.26 204.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M287.97 204.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M288.67 204.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M294.3 204.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M295 204.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M295.71 204.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M296.41 204.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M209.88 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M210.58 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M211.29 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M217.62 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M221.14 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M221.84 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M222.54 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M223.95 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M225.36 204.99l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M226.06 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M226.76 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M227.47 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M228.17 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M235.21 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M241.54 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M242.24 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M242.94 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M244.35 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M262.64 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M263.58 205.43l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M264.99 205.43l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M271.08 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M276.71 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M278.82 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M279.53 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M280.93 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M281.64 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M283.04 204.99l.704.67-.704-.67m2.345.446l.235.447-.235-.447z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M285.86 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M286.56 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M287.26 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M289.38 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M290.08 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M290.78 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M291.49 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M292.19 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M292.89 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M296.41 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "M297.11 204.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M297.82 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M298.52 204.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M208.47 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M209.18 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M209.88 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M212.69 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M213.4 205.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M214.1 205.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M215.51 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M217.62 205.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M219.03 205.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M219.73 205.66l.703 2.008-.703-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M221.14 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M221.84 205.66v2.678h1.407v-2.678h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M223.25 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M223.95 205.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M225.36 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M226.76 205.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M227.47 205.66l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M228.17 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M235.21 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M238.02 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M239.72 206.6v1.613h3.322l-3.322-1.613z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M240.83 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M241.54 205.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "M244.35 205.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M267.57 205.66l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M268.27 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M270.62 206.1l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M271.08 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M280.23 205.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M281.17 206.1l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M282.34 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M283.04 205.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M284.45 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M286.56 205.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M287.26 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M287.97 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M289.38 205.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M290.08 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M290.78 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M291.49 207l2.11-.67-2.11.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M293.6 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M295 205.66l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M298.52 205.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M299.22 205.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M207.07 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M207.77 206.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M208.47 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M212.69 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M214.57 206.55l.47.223-.47-.223m1.641-.223l.705.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M217.62 206.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M221.14 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M225.59 206.77l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M226.06 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M227.94 206.55l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M228.87 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M236.14 206.77l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M236.61 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M237.32 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M238.02 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M244.35 206.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M245.06 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M263.35 206.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M268.97 206.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M278.12 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M278.82 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M279.53 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M280.23 206.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M284.45 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M285.15 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M286.56 206.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M287.26 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M287.97 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M289.38 206.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M290.78 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M292.19 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M292.89 206.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M293.6 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M295.71 206.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M299.22 206.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M299.93 206.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M300.63 206.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M206.36 207l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M207.07 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M212.69 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M214.1 207l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M214.8 207v2.678h.703L214.8 207z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M215.51 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M216.92 207l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M217.62 207l.704.67-.704-.67zm8.44 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M227.23 207.22l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M228.17 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M228.87 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M236.85 207.44l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M244.35 207l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M245.06 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M262.64 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M263.35 207l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M269.68 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M278.12 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M278.82 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M279.53 207l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M280.23 207l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M282.34 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M283.75 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M284.92 207.22l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M290.78 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M291.49 207l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M294.3 207l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M298.52 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M299.22 207l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M300.63 207l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M301.33 207l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M206.36 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M212.69 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M215.51 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M216.92 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M219.03 207.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M221.14 207.67l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M225.36 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M226.76 207.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M228.41 208.11l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M228.87 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M237.32 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M237.32 209l2.11-1.34-2.11 1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M239.43 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M245.06 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M262.64 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M266.86 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M266.86 209l2.11-1.34-2.11 1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M268.97 207.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M269.68 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M276.71 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M278.12 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M279.53 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M280.23 207.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M282.34 207.67l.703.67-.703-.67zm2.81 0l.703.67-.703-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M287.26 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M287.97 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M290.78 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M291.49 207.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M293.6 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M299.93 207.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M301.33 207.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M204.96 208.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M205.66 208.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M213.4 208.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M214.1 208.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M217.15 208.78l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M219.03 208.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M220.43 208.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M222.31 208.56l.47.223-.47-.223m1.641-.223l.705.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M226.06 208.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M228.87 208.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M243.65 208.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M245.06 208.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M261.94 208.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M262.64 208.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M271.08 208.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M280.23 208.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M284.45 208.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M285.15 208.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M286.56 208.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M291.49 208.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M292.89 208.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M293.6 208.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M294.3 208.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M295 208.34l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M297.82 208.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M298.52 208.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M300.63 208.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M302.04 208.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M302.74 208.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M204.96 209l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M213.4 209l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M214.1 209l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M215.51 209l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M218.32 209l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M219.03 209l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M221.14 209l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M223.25 209l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M226.76 209l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M227.47 209l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M228.17 209l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M244.35 209l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M245.06 209l.703.67-.703-.67m16.884 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M262.64 209l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "M263.35 209l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M281.64 209l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M282.34 209l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M284.45 209l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M285.15 209l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M287.97 209l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M290.08 209l.703.67-.703-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M292.89 209l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M295 209l.703.67L295 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M295.71 209l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M299.22 209l-.703 2.678h.703V209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M299.93 209l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M301.33 209l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425a84",
    d: "M302.98 209.45l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M204.96 209.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M213.4 209.67l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M215.51 209.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M216.92 209.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M219.03 209.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M242.24 209.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M242.94 209.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M243.65 209.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M244.35 209.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M264.05 209.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M264.75 209.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M265.46 209.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M285.86 209.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M287.97 209.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M288.67 209.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M290.08 209.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M292.19 209.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M295.71 209.67l-.703 2.008.703-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M297.11 209.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M297.82 209.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M298.52 209.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M299.93 209.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M301.33 209.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M204.96 210.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M213.4 210.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M216.21 210.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M218.32 210.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M226.76 210.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M227.47 210.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M228.17 210.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M228.87 210.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M238.02 210.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c9c",
    d: "M238.72 210.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M242.24 210.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M265.46 210.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c9c",
    d: "M268.97 210.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M269.68 210.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M278.82 210.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M279.53 210.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M280.23 210.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M280.93 210.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M290.08 210.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M290.78 210.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M292.19 210.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M292.89 210.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M294.3 210.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M295 210.34l.703.67-.703-.67m2.58.223l.468.223-.468-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M299.93 210.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M301.33 210.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M302.74 210.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M204.96 211.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M205.66 211.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M214.1 211.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M214.8 211.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M219.73 212.35l2.11-.67-2.11.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M221.84 211.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M222.54 211.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M223.25 211.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M223.95 211.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M224.65 211.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M225.36 211.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M226.06 211.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M226.76 211.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M227.47 211.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M280.23 211.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M280.93 211.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M281.64 211.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M282.34 211.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M283.04 211.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M283.75 211.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M284.45 211.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M285.15 211.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M285.86 211.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M287.03 211.24l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M292.89 211.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M296.41 211.01l.703.67-.703-.67zm1.41 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M299.22 211.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M300.63 211.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M302.74 211.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M204.96 211.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M205.66 211.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M220.43 211.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M221.14 211.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M221.84 211.68l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M286.56 211.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M287.26 211.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M287.97 211.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M295 211.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M295.71 211.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M296.41 211.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M297.82 211.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M298.52 211.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M302.04 211.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M302.74 211.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M203.55 212.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M204.25 212.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M205.19 212.8l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M217.62 212.35l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M218.32 212.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M219.03 212.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M220.43 212.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M286.56 212.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M287.26 212.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M287.97 212.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M288.91 212.8l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M296.41 212.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M297.11 212.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M299.93 212.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M302.74 212.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M303.45 212.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M304.15 212.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M202.85 213.02l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M203.55 213.02l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M204.25 213.02c-2.02 2.108-4.886 4.447-3.518 7.363-3.733 2.017-4.397 6.38-5.628 10.04l7.74 1.34 5.627-12.718-7.738.67v-.67l7.035-.67-3.517-5.354z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M214.1 213.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M214.8 213.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M215.98 213.24l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M217.62 213.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M221.14 213.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M286.56 213.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M287.26 213.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M291.49 213.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M297.82 213.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M298.52 213.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M304.15 213.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M304.85 213.02l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M204.96 213.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M205.66 213.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M211.99 213.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M213.16 213.91l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M214.1 213.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M221.14 213.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M286.56 213.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M291.49 213.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M292.19 213.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M293.36 213.91l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M294.53 214.14l.235.446-.235-.446m10.318-.446l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M205.66 214.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M210.11 214.81l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M211.05 214.58l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M216.21 214.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M220.43 214.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M221.14 214.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M285.86 214.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M286.56 214.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M287.73 214.58l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M288.67 214.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M289.38 214.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M290.08 214.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M295.47 214.58l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M305.56 214.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M200.73 215.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M201.44 215.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M205.66 215.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M206.36 215.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M208.94 215.25l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M214.1 215.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M214.8 215.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M215.51 215.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M220.43 215.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M221.14 215.03l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M285.86 215.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M286.56 215.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M287.26 215.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M290.08 215.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M291.25 215.25l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M292.19 215.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M296.41 215.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M297.11 215.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M297.82 215.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M306.26 215.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M306.96 215.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M200.73 215.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M208.47 215.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M213.16 215.92l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M214.1 215.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M219.73 215.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M287.26 215.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M287.97 215.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M292.19 215.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M292.89 215.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M293.6 215.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M306.96 215.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M307.67 215.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M200.03 216.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M200.73 216.37l.703.67-.703-.67m5.628 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M211.76 216.59l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M217.62 216.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M218.32 216.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M219.03 216.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M219.73 216.37l.703.67-.703-.67m68.24 0l.702.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M288.67 216.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M289.38 216.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M290.08 216.37l.703.67-.703-.67m3.518 0l-.704 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M294.3 216.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M295 216.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M307.67 216.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M199.33 217.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M200.03 217.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M207.77 217.04l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M210.35 217.26l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M214.1 217.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M214.8 217.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M215.51 217.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M216.21 217.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M216.92 217.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M217.62 217.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M290.08 217.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M290.78 217.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M291.49 217.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M292.19 217.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M293.6 217.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M294.3 217.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M295 217.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M295.71 217.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M296.41 217.04l.703.67-.703-.67m2.814 0l.704.67-.704-.67m8.442 0l.703.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M308.37 217.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M199.33 217.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M207.77 217.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M209.18 217.71l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M211.99 217.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M212.69 217.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M214.1 217.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M214.8 217.71l.703.67-.703-.67m78.088 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M293.6 217.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M295 217.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M295.71 217.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M298.52 217.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M308.37 217.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M198.62 218.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M199.33 218.38l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M204.96 218.38l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M209.88 218.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M210.58 218.38l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M211.29 218.38l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M214.1 218.38l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M292.19 218.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M292.89 218.38l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M295.47 218.6l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M296.41 218.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M297.11 218.38l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080829",
    d: "M297.82 218.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M301.33 218.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M309.07 218.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M198.62 219.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M200.73 219.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M201.91 219.27l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M202.85 219.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M209.18 219.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M209.88 219.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M298.52 219.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M299.22 219.05l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M303.45 219.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M304.62 219.27l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M305.79 219.49l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M309.07 219.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M197.92 219.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M207.77 219.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M208.47 219.71l-.704 1.34.704-1.34m90.75 0l1.408 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M299.93 219.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M306.26 219.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M306.96 219.71l2.814 2.678-2.814-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M309.07 219.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M309.78 219.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M197.92 220.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M198.62 220.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M207.07 220.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101831",
    d: "M300.63 220.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M309.78 220.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M197.22 221.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M197.92 221.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M206.36 221.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M207.07 221.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M213.4 221.05l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M214.1 221.05v.67h80.902l-24.622-.67H214.1m86.53 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M301.33 221.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M309.78 221.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M310.48 221.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M197.22 221.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M197.92 221.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M206.36 221.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M213.4 221.72l3.518 3.347-3.518-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M214.1 221.72l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M214.8 221.72l5.907 7.363.424 26.106h6.333c0-8.335 1.86-16.855-4.22-23.43l8.44 5.355-3.517-10.04 19.698 18.742-14.773-22.76 14.07 18.075h.705V221.72H214.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M247.87 221.72v20.082h.703l-.703-20.082z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M259.83 221.72v20.082h.704l-.704-20.082z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M260.53 221.72v18.743l14.773-17.404-14.773 22.758 20.4-18.743-4.22 9.371 8.442-5.355c-4.55 8.335-4.22 14.558-4.22 24.1h6.33l.424-26.107 5.908-7.363H260.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M293.6 221.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M294.3 221.72l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M301.33 221.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M302.04 221.72l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M310.48 221.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M196.51 222.39l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M197.22 222.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M205.66 222.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M206.36 222.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M292.89 222.39l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M302.04 222.39l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M309.07 222.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M310.48 222.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M311.18 222.39l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M196.51 223.06l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M197.22 223.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M205.66 223.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M233.1 223.06l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M302.04 223.06l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M310.01 223.51l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M311.18 223.06l.704.67-.704-.67m-115.14 1.116l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M196.51 223.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M204.96 223.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M205.66 223.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M216.21 223.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M233.1 223.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M233.8 223.73l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M274.6 223.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M292.19 223.73l-4.22 4.686 4.22-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M302.04 223.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M302.74 223.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M311.18 223.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M196.51 224.4l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M204.96 224.4l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M216.92 224.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M233.1 224.4l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a00",
    d: "M233.8 224.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M273.19 224.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "M273.9 224.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M302.74 224.4l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M311.18 224.4l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M311.89 224.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M195.81 225.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M204.25 225.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M204.96 225.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M216.92 225.07l3.518 3.347-3.518-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M217.62 225.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "M233.8 225.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cea508",
    d: "M234.74 225.52l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M235.21 225.07l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M272.49 225.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#634a00",
    d: "M273.9 225.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M274.6 225.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M302.74 225.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M303.45 225.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M311.89 225.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M195.81 225.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M204.25 225.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M218.32 225.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M233.8 225.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M235.21 225.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M271.79 225.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M273.19 225.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M273.9 225.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M303.45 225.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M311.89 225.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M195.11 226.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M195.81 226.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M204.25 226.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M219.03 226.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#634a00",
    d: "M234.5 226.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb508",
    d: "M235.21 226.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M235.91 226.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M271.79 226.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M273.9 226.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M303.45 226.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M304.15 226.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M311.89 226.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M312.59 226.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M195.11 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M195.81 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M203.55 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M204.25 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M219.73 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M228.41 227.52l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M234.5 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M235.21 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M235.91 227.08l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M236.61 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M271.08 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M271.79 227.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M272.49 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M273.19 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M279.53 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M280.23 227.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M287.97 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M304.15 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M312.59 227.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M195.11 227.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M203.55 227.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M220.43 227.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M228.87 227.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M229.58 227.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M235.91 227.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M237.32 227.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M270.38 227.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M271.55 227.97l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M272.49 227.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M278.12 227.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M278.82 227.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M279.53 227.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M287.26 227.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M304.15 227.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M312.59 227.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M195.11 228.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M203.55 228.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M220.43 228.42v27.445h.704c0-7.83 2.47-20.25-.704-27.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#634a00",
    d: "M228.87 228.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7300",
    d: "M229.58 228.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M230.28 228.42l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M235.91 228.42l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M236.61 228.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M237.32 228.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M269.68 228.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M270.38 228.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M271.08 228.42l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M271.79 228.42l.704.67-.704-.67m5.628 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "M278.12 228.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a00",
    d: "M278.82 228.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M279.53 228.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M287.26 228.42v26.776h.703c0-7.654 2.4-19.74-.703-26.776z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M304.15 228.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M312.59 228.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M313.29 228.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M194.4 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M195.11 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M202.85 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M203.55 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M228.87 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "M229.58 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cea508",
    d: "M230.28 229.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M230.99 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M231.69 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M236.61 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M237.32 229.09l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M238.02 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M269.68 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M271.08 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M276.01 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M276.71 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "M277.42 229.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M278.12 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M278.82 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M304.15 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M304.85 229.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M313.29 229.09l.703.67-.703-.67m-118.89.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M202.85 229.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M203.55 229.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313918",
    d: "M229.58 229.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M230.28 229.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad8c08",
    d: "M230.99 229.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M231.69 229.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M237.32 229.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M238.72 229.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M268.97 229.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M271.08 229.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M276.01 229.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "M276.71 229.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M277.42 229.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#634a00",
    d: "M278.12 229.76l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M278.82 229.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M304.85 229.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M306.26 229.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M313.29 229.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M193.7 230.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M194.4 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M195.11 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M195.81 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M196.51 230.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M197.22 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M197.92 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M202.85 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M229.58 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "M230.28 230.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M230.99 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M231.69 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M232.39 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M238.02 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M238.72 230.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M239.43 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M268.27 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M270.38 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M275.31 230.43l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M276.71 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M278.12 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M304.85 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M306.26 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M309.78 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M310.48 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M311.18 230.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M311.89 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M312.59 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M313.29 230.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M195.11 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M195.81 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M196.51 231.09l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M198.62 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M199.33 231.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M200.03 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M202.85 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M204.25 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M204.96 231.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M230.99 231.09l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M231.69 231.09l4.925 4.686-4.925-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M232.39 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M238.02 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M238.72 231.09l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M239.43 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M268.27 231.09l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M268.97 231.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M269.68 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M276.71 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M277.42 231.09l.704.67-.704-.67m7.035 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M304.85 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M306.26 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M307.67 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M308.37 231.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M309.07 231.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M311.65 231.32l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M193 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M193.7 231.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M195.81 231.76l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M196.51 231.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M197.22 231.76l2.11 2.678-2.11-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M197.92 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M199.09 231.99l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M200.03 231.76l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M200.73 231.76l2.11 3.347-2.11-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M201.44 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M202.14 231.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M202.85 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M204.25 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M204.96 231.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M284.02 231.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M223.95 231.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M224.65 231.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M233.1 231.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M238.72 231.76l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M267.57 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M268.27 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M274.6 231.76l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M275.31 231.76l-2.11 2.678 2.11-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M276.71 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M283.04 231.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M283.75 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M284.45 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M296.64 232.21l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M299.93 231.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M300.63 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M304.85 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080829",
    d: "M305.56 231.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.26 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M306.96 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M307.67 231.76l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M308.37 231.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M310.48 231.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M311.18 231.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M193 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M193.7 232.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M195.81 232.43l.703.67-.703-.67m4.925 0l.703.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M201.91 232.66l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M203.55 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M204.25 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M204.96 232.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M205.66 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M223.95 232.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7300",
    d: "M224.65 232.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "M225.36 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M226.06 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M231.69 232.43v4.686h.703l-.703-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M233.8 232.43l.703.67-.703-.67m5.628 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M240.83 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M266.86 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M266.86 233.77l2.11-.67-2.11.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M268.97 232.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M275.31 232.43l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b1821",
    d: "M276.01 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M281.64 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M282.34 232.43l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7300",
    d: "M283.04 232.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M283.75 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M297.11 232.43l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M300.63 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M301.33 232.43l.703.67-.703-.67m3.283.223l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.56 232.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.26 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M306.96 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M307.67 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M310.48 232.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M311.18 232.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M193 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M194.17 233.33l.47.223-.47-.223m2.814 0l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M199.33 233.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M200.03 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M201.44 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M202.85 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M203.55 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.25 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M204.96 233.1l-1.407 5.355h-.703l1.407-4.686h-.704l-.703 5.354 2.814-1.338-3.518 5.355 2.814-2.007-3.517 2.677-.704 3.347h.703l7.035-8.032-2.11.67v-.67l2.11-.67v-.67h-2.814l-.704-4.685z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M205.66 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102121",
    d: "M224.65 233.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M225.36 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad8c08",
    d: "M226.06 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102121",
    d: "M226.76 233.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M227.47 233.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M232.39 233.1c.067 5.37 3.225 7.87 7.738 10.71-.357-4.51-4.177-7.979-7.738-10.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M233.1 233.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M234.5 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M239.43 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M240.6 233.33l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M241.54 233.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M266.16 233.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M267.57 233.1l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M268.27 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M275.31 233.1l-7.035 10.71c3.894-2.317 9.184-5.778 7.035-10.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M280.23 233.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "M280.93 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c7b08",
    d: "M281.64 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M282.34 233.1l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M283.75 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M300.63 233.1l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M301.33 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M304.62 233.33l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M305.56 233.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M306.26 233.1l.703 14.057h.704l2.11-12.05h-.703l-1.407 8.034h-.703l-.704-10.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M306.96 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M307.67 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M309.78 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M311.18 233.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M312.59 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M313.29 233.1l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M315.4 233.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M193 233.77l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M194.4 233.77l.703 2.008h.704l-1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M195.11 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M197.22 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M197.92 233.77l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M199.33 233.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M200.03 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M200.73 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M202.85 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M204.49 234.22l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M205.66 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M206.36 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a4208",
    d: "M225.36 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M226.06 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "M226.76 233.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M227.47 233.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M233.8 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M235.21 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M240.13 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M240.83 233.77l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M241.54 233.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M255.61 233.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M266.16 233.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M267.57 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M272.49 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M273.9 233.77l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M274.6 233.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M280.23 233.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "M280.93 233.77l.703.67-.703-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M283.04 233.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M296.41 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M297.11 233.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M297.82 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M300.63 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M304.85 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M305.56 233.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b8c73",
    d: "M306.96 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M309.07 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M309.78 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M313.29 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M314.7 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M315.4 233.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M193 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M197.92 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M198.62 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M199.33 234.44l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M200.03 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M200.73 234.44l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M202.85 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M206.36 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M225.36 234.44l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a00",
    d: "M226.06 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M226.76 234.44l2.11 1.34-2.11-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M228.17 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M234.5 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M235.91 234.44l.704.67-.704-.67m4.925 0l.703.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M242.24 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "M253.5 234.44v.67l1.407 2.677h.703l-2.11-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M265.46 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M266.86 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M267.57 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M271.79 234.44l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M272.49 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M273.9 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M279.53 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M280.23 234.44l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M280.93 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a00",
    d: "M281.64 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M282.34 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M296.41 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.11 234.44l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M297.82 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M300.63 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.33 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M302.04 234.44l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M304.85 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.56 234.44l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M306.96 234.44v3.347h.703l-.703-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M308.37 234.44l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.54 234.66l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M310.48 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M311.18 234.44l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M312.36 234.66l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M313.29 234.44l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M314 234.44l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M314.7 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M315.4 234.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M192.29 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M193 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M195.81 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M197.92 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M198.62 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M199.33 235.11v2.008l2.11-.67v-.67l-2.11-.668z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M200.73 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M202.14 235.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.02 235.33l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M206.36 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M226.76 235.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M228.87 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M234.5 235.11l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M235.21 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M236.61 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M241.54 235.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M242.48 235.56l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M242.94 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "M252.79 235.11v2.678h.704l-.704-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M253.5 235.11v3.347h-2.814v2.008h2.814v8.033h.704l.703-8.033h3.517v-2.008h-3.517v-3.347H253.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M264.75 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M265.93 235.33l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M266.86 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M271.79 235.11l-2.11 2.678 2.11-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M273.19 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M278.82 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M280.93 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M281.64 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M297.11 235.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297.82 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M298.52 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M300.63 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M301.33 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M302.04 235.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M304.85 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M308.37 235.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M309.78 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M310.48 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M311.18 235.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M311.89 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M313.29 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M314 235.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M314.7 235.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M193.7 235.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M194.4 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M195.58 236l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M196.51 235.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M197.92 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M198.62 235.78c-1.91 4.1-1.667 6.585 0 10.71h1.407l1.407-10.04h-.703l-.703 8.032h-1.407v-8.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M201.44 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M203.78 236.23l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M206.36 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M227.47 235.78l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M228.17 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M228.87 235.78l2.814 2.678-2.814-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M229.58 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M235.91 235.78l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M236.61 235.78l2.814 3.347-2.814-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M237.32 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M241.54 235.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M242.94 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M264.75 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M265.46 235.78l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M266.16 235.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M270.38 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M272.49 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M278.12 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M280.23 235.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M297.11 235.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M297.82 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M298.52 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M299.22 235.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M300.63 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.33 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M302.04 235.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M302.74 235.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M304.85 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M308.37 235.78l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M310.48 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M311.65 236l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M312.59 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M313.29 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M314 235.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M314.7 235.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M197.92 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M201.44 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M206.36 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M227.47 236.45v18.743h-6.33v.67l7.034-.67v3.347h.703c0-5.777 2.308-17.424-1.407-22.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M228.87 236.45l.703.67-.703-.67m1.407 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M238.02 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M242.24 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M242.94 236.45l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M243.65 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M264.05 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M265.46 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M269.68 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M271.79 236.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M276.71 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M277.42 236.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M278.12 236.45l-2.11 2.678 2.11-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M278.82 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M279.53 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M280.23 236.45v18.743h.704l-.704-18.743z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M297.11 236.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.29 236.67l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M299.22 236.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M300.63 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.33 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M302.04 236.45l2.814 16.735h.703c1.165-5.97.057-11.613-3.517-16.735z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M302.74 236.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M304.15 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.85 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M308.37 236.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M309.78 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M312.59 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M313.29 236.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M314 236.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M196.51 237.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M197.22 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M199.56 237.57l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M201.44 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M203.31 237.34l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M205.66 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M206.83 237.34l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M207.77 237.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M208.47 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M209.18 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M209.88 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M228.87 237.12c0 5.062-2.5 18.23.723 22.29 1.415 1.782 4.9 1.956 7.015 2.478 0-10.244 2.075-18.383-7.738-24.767z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M229.58 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M230.99 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M231.69 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M236.61 237.12l.703.67-.703-.67m2.11 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M242.94 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M244.35 237.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M263.35 237.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M263.35 238.46l2.11-1.34-2.11 1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M265.46 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M268.97 237.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M271.08 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1831",
    d: "M276.01 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M276.71 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M278.12 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M271.79 261.89c2.29-.565 5.6-.767 7.314-2.48 3.624-3.615 1.128-17.412 1.128-22.288-10.98 4.843-8.442 15.064-8.442 24.767z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M297.11 237.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.82 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M298.52 237.12l5.628 21.42h-.703c-1.12-3.75-5.566-18.02-11.256-12.718 7.536.308 10.027 13.084 11.255 18.743h.703l9.145-26.776h-.703l-7.035 17.403h-.704c-1.9-5.697-1.75-13.722-6.33-18.074z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.22 237.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M299.93 237.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M300.63 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.33 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.74 237.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M303.45 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M304.15 237.12l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.85 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M307.67 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M309.78 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M311.89 237.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M313.06 237.34l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M314 237.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M196.51 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M201.44 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M202.85 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.25 237.79l-2.814.67v.67l2.814-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M204.96 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M208.71 238.23l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M209.18 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M209.88 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M210.58 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M230.28 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M231.69 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M232.39 237.79l1.407 1.34-1.407-1.34m4.925 0l.703.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M238.72 237.79l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M239.43 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M244.12 238.01l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M245.06 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M249.28 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada584",
    d: "M249.98 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c7b08",
    d: "M252.79 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cea508",
    d: "M254.9 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9463",
    d: "M255.61 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdb584",
    d: "M256.31 237.79v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M258.42 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M262.64 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M264.75 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M268.27 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M268.97 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M269.68 237.79l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M270.38 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M275.31 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M276.01 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M277.42 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M294.3 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M295 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M297.82 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M299.93 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M300.63 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.33 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.74 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M304.15 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M306.96 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M307.67 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M309.78 237.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M311.18 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M311.89 237.79l.703.67-.703-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M314 237.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M196.51 238.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M199.33 238.46v2.008h.704l-.704-2.008m4.925 0l.703.67-.704-.67m3.284.223l.468.223-.468-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M209.18 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M209.88 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M230.99 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M231.69 238.46v.67l2.11.67-2.11-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M238.02 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M240.13 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M243.65 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M244.35 238.46l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M245.06 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "M249.98 238.46v2.008h.704l-.704-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M262.64 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M263.35 238.46l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M264.05 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M267.57 238.46l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M268.27 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M269.68 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M274.6 238.46l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M275.31 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M276.71 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M295 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M295.71 238.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M297.82 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.93 238.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M300.63 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M301.33 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M303.45 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.15 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.96 238.46v4.016h.703l-.703-4.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.67 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M309.78 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M311.18 238.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M311.89 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M313.29 238.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M196.51 239.13l.704.67-.704-.67m5.628 0l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M206.36 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M207.07 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M208.47 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M209.18 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M231.69 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M233.8 239.13l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M238.72 239.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M239.43 239.13l5.628 5.355-5.628-5.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M244.35 239.13l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M261.94 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M263.35 239.13l.704.67-.704-.67m4.22 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M268.97 239.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M273.9 240.47l2.11-.67-2.11.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M276.01 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M295.71 239.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M297.82 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.52 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "M300.63 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M301.33 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.45 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.15 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.07 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M309.78 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M310.48 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M311.18 239.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M312.59 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M313.29 239.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M195.81 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M196.51 239.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M202.14 239.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M202.85 239.8l-.704 2.008h.704V239.8m2.814 0l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M207.77 239.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M208.47 239.8l.703.67-.703-.67m2.814 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M232.39 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M233.8 239.8l2.814 2.678-2.814-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M239.43 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M240.83 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M245.06 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M246.46 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M261.24 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M261.24 241.14l2.11-.67-2.11.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M263.35 239.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M266.86 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M267.57 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M268.27 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M273.19 239.8l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M274.6 239.8l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M275.31 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#426331",
    d: "M295 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M295.71 239.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M296.41 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.52 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.63 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M301.33 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.15 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M309.07 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M309.78 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M310.48 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M311.18 239.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M312.59 239.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M196.04 240.91l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M199.33 240.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M201.67 240.91l.235.446-.235-.446m1.173-.446l.703.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M207.77 240.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M211.29 240.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M211.99 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M217.62 240.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M218.32 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M219.03 240.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M233.8 240.47l.703.67-.703-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M240.13 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M241.54 240.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M245.06 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M246.23 240.69l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M249.28 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada584",
    d: "M249.98 240.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c7b08",
    d: "M252.79 240.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cea508",
    d: "M254.9 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9463",
    d: "M255.61 240.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M258.42 240.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M260.53 240.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M261.94 240.47l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M262.64 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M266.16 240.47l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M266.86 240.47l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M267.57 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M273.19 240.47l-2.11 2.678 2.11-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M274.6 240.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M295 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.71 240.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M296.41 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M298.52 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.33 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.15 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.85 240.47l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M309.07 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M309.78 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M310.48 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M311.89 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M312.59 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M314.7 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M315.4 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M316.11 240.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M316.81 240.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M198.62 241.14v3.347h1.407v-3.347h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M204.25 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M207.07 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M207.77 241.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M210.58 241.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M211.29 241.14l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M211.99 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M216.21 241.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M216.92 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M217.62 241.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M218.32 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M219.03 241.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M234.5 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M235.91 241.14l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M236.61 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M240.83 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M242.24 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M245.76 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M246.46 241.14l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M247.17 241.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "M252.79 241.14v7.363h.704l-.704-7.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M260.53 241.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M261.94 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M266.86 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M267.57 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M271.79 241.14l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M295 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M295.71 241.14l3.518 6.024h.703l-4.22-6.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M296.41 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M297.11 241.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M298.52 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.22 241.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.33 241.14l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.04 241.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M304.85 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M309.07 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M309.78 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M310.48 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M311.89 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M312.59 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M314 241.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M314.7 241.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M311.18 245.82l7.035-2.008-1.407-2.678-5.628 4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M316.81 241.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M317.52 241.14l.703.67-.703-.67m-121.7.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M196.51 241.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M201.67 242.25l.235.446-.235-.446m1.876-.446l.703.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.25 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M207.07 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M210.58 241.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M211.29 241.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M212.69 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M215.51 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M216.21 241.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M214.1 251.85h-.704v-7.363h-.703l-.703 3.347h-.704v-3.347h-.703l-4.22 15.396h.702l1.407-2.678h.704l-1.407 3.347h.702l3.518-4.686-2.814 6.025h.703l7.11-10.04 1.33-10.04c-4.6 2.11-4.22 5.718-4.22 10.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M218.32 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M235.21 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M237.32 241.8l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M240.83 241.8l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M241.54 241.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M242.94 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M246.46 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.87 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M259.83 241.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M261.94 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M266.16 241.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M266.86 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M270.38 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M271.08 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M272.49 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M295.24 242.25l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.71 241.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M297.11 241.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M297.82 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M298.52 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.22 241.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.33 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.85 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M309.07 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M309.78 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M311.89 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M313.29 241.8l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M314 241.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M317.52 241.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M196.51 242.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M202.85 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M203.55 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M206.36 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M207.07 242.47l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M210.58 242.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M211.76 242.7l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M212.69 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M214.8 242.47l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M215.51 242.47l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M218.32 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M235.91 242.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M237.08 242.7l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M242.24 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M243.65 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M247.17 242.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M248.1 242.92l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M248.57 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M259.12 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M261.24 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M264.05 242.47l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M264.75 242.47l-3.518 4.016 3.518-4.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M265.46 242.47l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M266.16 242.47l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M269.68 242.47l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M270.38 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M271.79 242.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M293.6 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M294.3 242.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295.71 242.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.11 242.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M297.82 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M299.22 242.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.04 242.47v2.008h.704l-.704-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M305.32 242.7l.47.223-.47-.223m1.64-.223l.705.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M309.07 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.78 242.47l.703.67-.703-.67m1.407 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M311.89 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M313.29 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M317.52 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M318.22 242.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M196.51 243.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M200.73 243.14v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M202.85 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M204.96 243.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M205.66 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M209.88 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M210.58 243.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M210.58 243.81v.67l2.11.67v-2.01l-2.11.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M212.69 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M214.8 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M217.38 243.37l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M218.32 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M236.61 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M237.32 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M238.02 243.14l2.814 2.678-2.814-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M238.72 243.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M242.94 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M244.35 243.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M247.17 243.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M248.57 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M249.28 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M259.12 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M259.83 243.14l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M260.53 243.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M270.15 243.37l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M271.08 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M292.89 243.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M293.6 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.3 243.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "M295 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.71 243.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297.82 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M298.52 243.14l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M299.22 243.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M305.56 243.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M308.37 243.14l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M309.07 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M311.18 243.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M312.59 243.14l.703.67-.703-.67m1.407 0l-4.22 2.678v.67l1.406.668 2.814-4.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M314.7 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M315.4 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M316.11 243.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M316.81 243.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M318.22 243.14l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M196.51 243.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M197.22 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M200.73 243.81l.703.67-.703-.67m1.407 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M203.55 243.81l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M204.25 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M204.96 243.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M209.88 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M212.69 243.81l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M213.4 243.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M214.1 243.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M216.45 244.26l.235.446-.235-.446m1.173-.446v4.685h.703l-.704-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.61 243.81v18.074h.703l-.703-18.074z",
    fillOpacity: 0.481,
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M237.32 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M238.02 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M239.43 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M242.94 243.81l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M243.65 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M245.06 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M247.87 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M248.57 243.81l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M249.28 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M258.42 243.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M259.83 243.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M268.27 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M268.97 243.81l-2.11 2.678 2.11-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M269.68 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M270.38 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M271.08 243.81v18.074h.703l-.703-18.074m21.105 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.89 243.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.71 243.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M296.41 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M298.52 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.93 243.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M305.56 243.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.26 243.81l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M308.37 243.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M314 243.81l-1.407 2.008L314 243.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M314.7 243.81l-2.11 2.678 2.11-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M316.81 243.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M318.22 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M318.92 243.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M197.22 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M200.73 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M201.44 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M203.55 244.48l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M204.25 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M204.96 244.48l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M205.66 244.48l.703.67-.703-.67m3.518 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M209.88 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M238.02 244.48l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M238.72 244.48l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.13 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M240.83 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M244.35 244.48l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M245.06 244.48l2.814 3.347-2.814-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M245.76 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M247.87 244.48v2.008h.703l-.703-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M248.57 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M249.98 244.48l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M257.72 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M258.66 244.93l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M259.12 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M261.94 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M264.05 244.48l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M266.86 244.48l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M267.57 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M268.97 244.48l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M269.68 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M291.49 244.48l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.19 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M296.41 244.48l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.11 244.48l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M299.22 244.48l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.93 244.48l.704.67-.704-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.74 244.48l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.26 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M308.37 244.48l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M310.48 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M318.22 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M318.92 244.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M197.22 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M197.92 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M200.5 245.37l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M202.14 245.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M204.25 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M204.96 245.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M205.66 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M206.36 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M207.07 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M209.18 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M211.29 245.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M213.4 245.15v6.024h.704l-.704-6.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M215.98 245.37l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M239.43 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M240.83 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M241.54 245.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M246.46 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M248.57 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "M249.28 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M249.98 245.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M250.68 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M257.01 245.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M257.72 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M259.12 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M261.24 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M266.86 245.15l.703.67-.703-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M268.97 245.15l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M291.49 245.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.89 245.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M293.6 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M294.3 245.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.82 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.22 245.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.93 245.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M302.51 245.37l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.26 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.67 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M308.37 245.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M310.48 245.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M314.94 245.6l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M197.92 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M200.27 246.27l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M202.14 245.82l.704.67-.704-.67m2.345.446l.235.447-.235-.447z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M205.42 246.04l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M206.36 245.82l.703 6.024h.704l-1.407-6.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M207.07 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M207.77 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M208.47 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M240.13 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M240.83 245.82l2.11 1.34v-.67l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M241.54 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M245.06 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M247.17 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M249.28 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M249.98 245.82l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M250.68 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M251.39 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M257.01 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M257.72 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M258.42 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M260.53 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M265.46 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M266.16 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M267.57 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M290.78 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.49 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.19 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M292.89 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M293.6 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M294.3 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M295 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.11 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.93 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.04 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M302.74 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.26 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M307.67 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M310.48 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M311.89 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M313.29 245.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M314 245.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M195.11 246.49l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M195.81 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M197.92 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M198.62 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M199.33 246.49l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M201.44 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M204.96 246.49c-.15 3.57-.888 6.695 2.814 8.702l-2.814-8.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M205.89 246.94l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M207.77 246.49l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M208.47 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M240.83 246.49l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M245.76 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M247.17 246.49l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M247.87 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M249.98 246.49l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M251.39 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M256.31 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M257.01 246.49l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.72 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M258.42 246.49l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M259.12 246.49l-.704 2.008.704-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M259.83 246.49l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M260.53 246.49l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M261.24 246.49l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M261.94 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M264.75 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M265.46 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M266.16 246.49l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M266.86 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M290.08 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M291.25 246.71l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M292.19 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M295 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295.71 246.49l.704.67-.704-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.52 246.49l.703.67-.703-.67m1.407 0l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.63 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.74 246.49l.704.67-.704-.67m3.518 0l1.407 1.34-1.408-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M307.67 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M309.78 246.49l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M311.18 246.49l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M311.89 246.49l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M312.59 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M313.29 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M314 246.49l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M317.52 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M318.22 246.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M195.11 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M196.51 247.16l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M197.92 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M198.62 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M199.33 247.16l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M200.03 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M200.73 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M201.44 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M204.25 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M208.47 247.16l-.704 1.34.704-1.34m2.814 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M241.54 247.16l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M242.24 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M242.94 247.16l2.814 2.678-2.814-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M243.65 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M245.99 247.61l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M246.46 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M248.57 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M249.98 247.16l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "M250.68 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M252.09 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c7b08",
    d: "M254.9 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M255.61 247.16l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M256.31 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M257.01 247.16l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83 247.16l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M262.17 247.61l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M264.05 247.16l.703.67-.703-.67m2.11 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M290.08 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M290.78 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M291.49 247.16l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M295.71 247.16l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.41 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.52 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.52 248.5l2.11-.67-2.11.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M302.74 247.16l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.26 247.16v2.008h.703l-.703-2.008m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M309.78 247.16l-.703 2.008.703-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M311.89 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M312.59 247.16l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M313.29 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M314 247.16l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M316.11 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M316.81 247.16l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M317.52 247.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M318.22 247.16l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M195.11 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M195.81 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M196.51 247.83l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M197.22 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M197.92 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M200.03 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M200.73 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M204.25 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M206.13 248.05l.47.223-.47-.223m2.345-.223l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M210.58 247.83l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "M242.24 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M242.94 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M244.35 247.83l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M245.06 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M246.7 248.28l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M247.17 247.83l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M247.87 247.83l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M248.57 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M249.28 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M250.68 247.83l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M251.39 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M252.09 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a10",
    d: "M254.2 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M254.9 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M256.31 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M257.01 247.83l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M257.72 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M259.12 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M259.83 247.83l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M261.47 248.28l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M263.35 247.83l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M264.05 247.83l-2.11 2.678 2.11-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "M265.46 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M290.08 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M293.6 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M294.3 247.83l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M295.71 247.83l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M296.41 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.22 247.83l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M299.93 247.83l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.63 247.83l-.704 2.008.704-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.74 247.83l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M306.96 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.07 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M310.71 248.28l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M311.18 247.83l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M312.59 247.83l-4.925 7.363 4.925-7.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M313.29 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M314.7 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M315.4 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M316.11 247.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M316.81 247.83l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M195.11 248.5v1.34l1.407-1.34h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M196.51 248.5l1.407 2.678-2.11-1.34c.688 2.7 1.413 4.337 4.22 5.356v.67l-2.813-.67 1.407 2.008-2.11-.67 6.332 6.025.703-2.677 2.11 1.338-4.22-4.016v-.67l2.11.67c-1.027-4.063-3.114-6.76-7.035-8.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M197.22 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M197.92 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M198.62 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M200.03 248.5l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M200.73 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M201.44 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M204.25 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M206.36 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M207.77 248.5v6.024h.704l-.704-6.024m3.05.446l.233.447-.234-.447z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M215.51 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#527b31",
    d: "M217.62 248.5l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.24 248.5v14.727h.703l-.703-14.727z",
    fillOpacity: 0.575,
    fill: "#734a42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M242.94 248.5l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M243.65 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M245.06 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M245.76 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M247.17 248.5v1.34h1.407l-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M249.28 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M250.68 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M251.39 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "M252.09 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "M252.79 248.5l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M253.5 248.5l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M254.2 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M254.9 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M255.61 248.5l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M256.31 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M259.83 248.5l-2.814 1.34v.668l3.517-1.34-.703-.668z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M261.94 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M262.64 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M264.05 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M264.75 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M265.46 248.5l-.703 15.396h.703c1.27-4.087 1.75-11.427 0-15.396z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.3 248.5l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M296.41 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.11 248.5l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.22 248.5l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.93 248.5l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M303.21 248.72l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.96 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M309.78 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M311.18 248.5l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M313.29 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M314 248.5l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M314.7 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M315.4 248.5l-1.407.67v.67l1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M316.11 248.5l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M195.81 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M196.51 249.17l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M198.62 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M199.33 249.17l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M200.03 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M201.44 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "M202.14 249.17l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M202.85 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M203.55 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M204.25 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M215.27 249.39l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M217.62 249.17l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M242.94 249.17v14.057l7.738 1.34c-1.69-4.943-2.716-12.724-7.738-15.397z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M244.35 249.17l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M245.76 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M246.46 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M248.57 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "M249.28 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M250.21 249.61l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M252.79 249.17l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M253.73 249.61l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M254.2 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M257.01 249.17l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M259.83 249.17l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M260.53 249.17l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M261.24 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M261.94 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M263.35 249.17l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M264.05 249.17l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M264.75 249.17l-2.814 2.008 2.814 8.702-4.925 1.34.704 2.677 4.924-.67-.704-14.057z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M294.3 249.17l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M295 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M297.11 249.17l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.63 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.33 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M303.45 249.17v2.008h.703l-.703-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M306.26 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.96 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M309.07 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M309.78 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M310.48 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M312.59 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M313.29 249.17l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M314.7 249.84v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#426331",
    d: "M195.11 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M196.51 249.84l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M197.22 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M199.33 249.84l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M200.03 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M202.38 250.28l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M203.08 250.28l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M203.55 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.25 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M210.58 249.84l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M217.62 249.84l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M245.06 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M245.76 249.84l1.407 1.34v-1.34h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M247.17 249.84l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "M247.87 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M248.81 250.28l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M250.68 249.84v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M252.79 249.84l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M255.61 249.84l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M256.31 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M257.72 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M260.53 249.84l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M261.24 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M262.64 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M294.3 249.84l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M295.71 249.84l.704.67-.704-.67m1.64.446l.236.447-.235-.447z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.82 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.93 249.84l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M300.63 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.33 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.49 250.28l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M308.37 249.84l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M309.07 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M309.78 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M311.89 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M312.59 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M313.29 249.84l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M314 249.84l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M315.4 249.84l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M316.81 249.84l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M195.11 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M197.22 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M200.73 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M203.55 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M210.35 250.73l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M217.62 250.51l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M245.76 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.17 250.51l3.518 13.388c4.284-1.497 10.863-2.087 13.366-6.025l-12.663 4.017-4.22-11.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M247.87 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M249.28 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M249.98 250.51l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M253.5 250.51l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M254.2 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M256.31 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M258.66 250.95l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M259.12 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M260.3 250.73l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.24 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M261.94 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M294.3 250.51l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M295 250.51l5.628 21.42h-.704v-1.34h-.703l.704 6.026h-.703v-1.34h-.702v5.356h-.704c-.06-6.818-2.76-12.92-6.33-18.743l-1.408 1.338v.67c5.153 4.894 6.732 15.39 7.034 22.09h-1.407l-2.814-14.058h-.704l2.11 18.743h-.703l-2.814-14.057h-.705l2.11 21.42h-.703l-1.407-17.404h-.703l1.407 17.404h-.705l-.703-9.37h-.704l.704 11.38h-.704l-.703-9.373h-.704l-2.11 12.718 7.74-.668v-.67l-4.925-.67v-.668l18.29 4.685v-.67l-8.44-2.678v-.67l12.662 2.68c-3.97-4.813-9.023-4.04-14.773-3.348v-.67l16.18.67v-.67l-11.256-2.677v-.67l11.256.67v-.67c-8.045-1.75-12.078-.742-18.29 4.686L295 294.69h-.704l-.703 2.007h-.704l3.517-10.04h.703l-.703 7.362 16.18-6.025v-.67l-14.773 4.017c5.638-4.407 13.79-8.15 21.105-8.702v-.67c-8.423 0-12.94 1.932-19.7 6.694 5.294-6.566 13.515-7.24 21.106-10.04v-.67c-9.55.717-14.09 2.88-21.808 8.033 4.773-4.54 12.924-12.457 20.4-10.71l-1.406-3.347c-6.478 1.464-12.116 5.04-16.884 9.37 3.276-4.387 14.795-16.512 20.4-16.064-5.69-4.97-16.608 10.185-20.4 13.388l15.477-16.735-13.366 11.38 14.772-18.744v-.67c-7 2.46-9.068 10.783-14.07 15.397l10.552-16.735c-4.702 3.227-8.536 9.358-9.85 14.727-3.236.387-2.11 5.495-2.11 8.032h-.703c0-8.138-.98-18.033-6.33-24.767z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M295.71 250.51l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M296.41 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M297.82 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.63 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.33 250.51l.703.67-.703-.67m7.035 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M309.07 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.78 250.51l.703.67-.703-.67m1.407 0l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M311.89 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M313.29 250.51l-4.22 3.347v.67l4.22-4.017z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M314 250.51l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M314.7 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M315.4 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M316.11 250.51l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M195.11 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M195.81 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M197.92 251.18l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M201.44 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M202.14 251.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M202.85 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M203.55 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M206.36 251.18l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M209.88 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M213.4 251.18l.704.67-.704-.67m3.518 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M217.62 251.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M246.46 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M247.87 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M250.68 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M251.39 251.18v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M253.5 251.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M256.31 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M257.48 251.4l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M259.12 251.18l.703.67-.703-.67m1.407 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M261.24 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M292.89 251.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M293.6 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M294.3 251.18l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.71 251.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M296.41 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M297.11 251.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M297.82 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.52 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.63 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M301.33 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.45 251.18l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.15 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.02 251.4l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M308.37 251.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M309.07 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M311.18 251.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M314 251.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M314.7 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M315.4 251.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M195.11 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M195.81 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M201.44 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M202.14 251.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M203.55 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.25 251.85l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M209.88 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M212.69 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M214.57 252.07l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M216.92 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M246.46 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M247.87 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M249.28 251.85l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M249.98 251.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M250.68 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M256.08 252.07l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M257.01 251.85l1.407 4.016h.704l-2.11-4.016m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M260.06 252.29l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M260.53 251.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M261.24 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M261.94 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M292.89 251.85l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M296.41 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.11 251.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M297.82 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M298.52 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.22 251.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.33 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.45 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M305.56 251.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.67 251.85l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M308.37 251.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M310.48 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M312.59 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M313.29 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M314 251.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M314.7 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M315.4 251.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M195.81 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M202.14 252.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M203.55 252.52l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M204.25 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M209.88 252.52l.703.67-.703-.67m1.407 1.34l2.11-.67-2.11.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M214.1 252.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M216.92 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M246.46 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M249.28 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M251.39 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M252.09 252.52l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M254.9 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M257.72 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M258.89 252.74l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M260.53 252.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M261.24 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M261.94 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M292.89 252.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M293.6 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M294.3 252.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.41 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M297.11 252.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.82 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M298.52 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.22 252.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.8 252.74l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.15 252.52l.703.67-.703-.67m1.407 0l.704.67-.703-.67m2.11 0l.704.67-.703-.67m2.814 0l.705.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.89 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M312.59 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M314 252.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M314.7 252.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M195.11 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M195.81 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M196.51 253.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M200.03 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M202.14 253.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M204.25 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.96 253.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M211.99 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M212.69 253.18l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M213.4 253.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M214.1 253.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M216.21 253.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M216.92 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M246.46 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M248.57 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M249.98 253.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M251.15 253.41l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M252.09 253.18l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M254.9 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M255.61 253.18l1.407 2.008-1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M256.78 253.41l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M260.53 253.18l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M261.24 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M261.94 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M293.6 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M294.3 253.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.41 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M297.11 253.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M297.82 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M298.52 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M299.22 253.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M302.04 253.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M304.15 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M305.56 253.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.96 253.18l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M307.67 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M309.78 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M311.18 253.18l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M311.89 253.18l.703.67-.703-.67m1.407 0l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M314 253.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M314.7 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M315.4 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M316.11 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "M316.81 253.18l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M317.52 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M318.22 253.18l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M195.11 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M195.81 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M196.51 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M200.03 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M200.73 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M202.85 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M204.96 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M211.29 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M212.69 253.85l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M213.4 253.85l.704.67-.704-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M216.21 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M247.17 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M248.57 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M249.28 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M249.98 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M253.5 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M254.2 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M254.9 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M256.31 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M258.42 253.85v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M260.53 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M261.94 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M262.64 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M293.6 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M294.3 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M295 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.11 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.11 255.19l2.11-.67-2.11.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M299.22 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.93 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M302.04 253.85l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.74 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.96 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M311.18 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M313.29 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M314 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M314.7 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M315.4 253.85l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M318.22 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M318.92 253.85l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M319.63 253.85l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M320.56 254.3l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M195.11 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M195.81 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M196.51 254.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M197.22 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M197.92 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M200.73 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M201.67 254.97l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M202.85 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M204.96 254.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M205.66 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M207.77 254.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M210.58 254.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M212.69 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M214.8 254.52l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M215.51 254.52l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M247.17 254.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M249.28 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M250.68 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M251.86 254.75l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M252.79 254.52l.704.67-.704-.67m2.58.223l.468.223-.468-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M257.01 254.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M257.72 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M261.94 254.52l-2.814.67v.67l3.518-.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M262.64 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M293.6 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M294.3 254.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M295 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.82 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M298.52 254.52l2.814 11.38h.703c-.035-4.11-.55-8.216-3.517-11.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.22 254.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.93 254.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.04 254.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.85 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.96 254.52l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M309.78 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M310.48 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M312.59 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M313.29 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M314 254.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M316.11 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M316.81 254.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M317.52 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "M318.22 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M318.92 254.52l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M319.63 254.52l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M195.11 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M195.81 255.19l2.11 1.34-2.11-1.34m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M198.62 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M199.33 255.19l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M202.85 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M203.55 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M205.66 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M206.36 255.19v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M209.88 255.19l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M227.47 255.19l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M247.17 255.19l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M249.28 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M249.98 255.19l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M250.68 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M251.62 255.64l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M254.43 255.64l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M255.14 255.64l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M255.84 255.64l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M256.31 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M257.01 255.19l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M261.94 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M262.64 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M280.23 255.19l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M280.93 255.19v.67h6.33l-6.33-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M287.26 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M291.49 255.19l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M293.6 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.3 255.19l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M295 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.82 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.22 255.19l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M299.93 255.19l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.63 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.98 255.64l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.26 255.19l.703.67-.703-.67m2.11 0l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M309.07 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M309.78 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M311.89 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M312.59 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M313.29 255.19l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M314 255.19l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M315.4 255.19l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M316.11 255.19l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M195.81 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M200.5 256.09l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M203.55 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M206.36 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M207.07 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M209.18 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M209.88 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M211.29 255.86l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M213.4 255.86l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M214.1 255.86l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M220.43 255.86l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.14 255.86v.67h6.33v10.04c3.817-6.062.247-10.705-6.33-10.71z",
    fillOpacity: 0.309,
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M227.47 255.86l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M247.87 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M249.28 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M250.68 256.53v.67l3.518-.67h-3.518m7.035-.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M258.42 255.86l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M259.12 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M262.64 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M263.35 255.86l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M280.23 255.86l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M280.93 255.86v.67h6.33l-6.33-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M287.26 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M291.49 255.86l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M292.19 255.86l.703.67-.703-.67m1.64.446l.236.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M294.3 257.2l2.11-.67-2.11.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.82 255.86l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.52 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.93 255.86l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.63 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.26 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M306.96 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M307.67 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M311.89 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M313.29 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M314.7 255.86l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M195.81 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M197.22 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M197.92 256.53l.703.67-.703-.67m3.986.223l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M203.55 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M206.36 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M207.07 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M209.18 256.53l.703.67-.703-.67m1.407 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M211.29 256.53l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M212.69 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M213.4 256.53l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M220.43 256.53v5.355h.704l-.704-5.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M247.87 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M249.98 256.53l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M252.09 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M254.9 256.53l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M255.61 256.53l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M256.78 256.75l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M257.72 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M259.12 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M259.83 256.53l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M261 256.75l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M261.94 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M262.64 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M263.35 256.53l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M280.23 256.53v8.702h.704l-.704-8.702m7.035 0v10.04h.703l-.703-10.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M291.49 256.53l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M292.19 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M295 256.53l3.518 12.05h.703L295 256.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.71 256.53l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.82 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.87 256.98l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M302.74 256.53l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.45 256.53l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M305.56 256.53l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M307.43 256.75l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M308.37 256.53l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M311.18 256.53l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.89 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M312.59 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M314.7 256.53l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M195.81 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M196.51 257.2l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M198.62 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M199.56 257.65l.235.446-.235-.446m2.58-.446l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M202.85 257.2l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M203.55 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M206.36 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M207.07 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M208.47 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M209.88 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M210.58 257.2l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M211.99 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M212.69 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M247.87 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M249.98 257.2l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M252.09 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M252.79 257.2l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M253.5 257.2v.67h2.11l-2.11-.67m2.814 0l-2.11 1.34v.668l2.11-2.008m2.11 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M259.12 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M259.83 257.2l.704.67-.704-.67m2.814 0l-.703 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M263.35 257.2l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M291.49 257.2l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.42 257.65l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M292.89 257.2l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.3 257.2l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295.71 257.2l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.41 257.2l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.52 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.33 257.2l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M303.68 257.65l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M305.56 257.2l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M308.37 257.2l.704.67-.704-.67m2.814 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M311.89 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M314 257.2l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M314.7 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M317.4 260.45l-2.814 4.686c1.887-1.316 3.672-2.43 2.814-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M321.74 257.2l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M196.51 257.87l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M197.22 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M200.03 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M204.25 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M206.36 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M207.77 257.87l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M208.47 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M209.88 257.87l.703.67-.703-.67m1.407 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M211.99 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M214.57 258.09l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M248.57 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M249.98 257.87l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M251.39 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M252.09 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M252.79 257.87l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M257.72 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M258.42 257.87l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.64 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M264.05 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M291.49 257.87l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.89 257.87l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M293.6 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M294.53 258.32l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.41 257.87l.703.67-.703-.67m2.11 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.22 257.87l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.33 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.85 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M305.56 257.87l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.26 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M307.67 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M311.18 257.87l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M313.29 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M314 257.87l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M320.33 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M321.03 257.87l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M197.22 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M200.73 258.54l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M201.44 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M204.25 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M205.42 258.76l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M206.36 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M207.77 258.54l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M209.18 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M209.88 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M211.29 258.54l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M214.1 258.54l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M214.8 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M228.17 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M248.57 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M250.68 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M253.5 258.54l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M256.31 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M257.01 258.54l.704.67-.704-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M259.83 258.54l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M260.53 258.54l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M264.05 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M292.89 258.54l4.925 16.065h.703c-.05-5.603-1.818-11.69-5.628-16.065z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M293.6 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M296.41 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.22 258.54l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.57 258.99l.235.446-.235-.446m3.283-.446l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M305.56 258.54l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.26 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M307.67 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M310.48 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M313.29 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M314 258.54l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M315.4 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M316.11 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M318.92 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M319.63 258.54l-1.407 2.678 1.407-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M320.33 258.54l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M197.22 259.21l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M197.92 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M202.14 259.21l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M204.96 259.21l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M205.66 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M207.07 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M207.77 259.21l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M209.18 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M210.58 259.21l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M211.29 259.21l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M213.4 259.21l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M214.8 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M228.17 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M248.57 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M250.68 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M251.62 259.66l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M252.09 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M252.79 259.21l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M253.5 259.21l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M257.01 259.21l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M257.72 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M258.42 259.21l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M263.35 259.21l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M264.05 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M279.53 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M292.42 259.66l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M293.6 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.53 259.66l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M296.88 259.43l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.22 259.21l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M305.32 259.43l.47.224-.47-.224m1.64-.223l.705.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M309.78 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M312.59 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M313.29 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M314 259.21l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M314.7 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M315.4 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M316.11 259.21l.703.67-.703-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M318.22 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M318.92 259.21l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M189.48 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M190.18 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M198.62 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M199.33 259.88l1.407 1.34-1.407-1.34m4.22 0l.704.67-.703-.67m1.408 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M205.66 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M206.36 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M207.07 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M208.47 259.88v1.34h1.407l-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M209.18 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M210.58 259.88l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M212.69 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M214.8 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M215.51 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M228.17 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M228.87 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M229.58 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M249.28 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M250.68 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M252.09 259.88l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M254.9 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M256.08 260.1l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M257.01 259.88l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M257.72 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M261.24 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M261.94 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M278.12 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M278.82 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M279.53 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295 259.88l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.11 259.88l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.22 259.88l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.93 259.88l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.33 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.04 259.88l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M304.38 260.32l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M305.56 259.88l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M306.26 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.96 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M309.54 260.1l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M312.59 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M313.29 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M314.47 260.1l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M315.4 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M316.81 259.88l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M317.52 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M318.22 259.88l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "M189.48 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M190.18 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M199.33 260.55l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M203.55 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M204.25 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M205.66 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M206.83 260.77l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M207.77 260.55l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M210.58 260.55l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M211.99 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M212.69 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M209.72 267.39h-.703c-.13-3.835-1.626-6.29-5.628-7.363.097 2.042 1.564 10.015 4.923 7.363h.704l-1.407 6.024c2.1-2.215 10.778-10.023 7.017-13.46-3.22-2.943-4.87 5.967-4.907 7.436z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M214.1 260.55l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M215.51 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M229.58 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M230.28 260.55l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M230.99 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M231.69 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M249.28 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M251.39 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M252.79 260.55l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M253.5 260.55l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M259.83 260.55l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M260.53 260.55l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M276.01 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M276.71 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M277.42 260.55l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M278.12 260.55l.703.67-.703-.67m11.96 0l.702.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M290.78 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M291.49 260.55l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M292.19 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.11 260.55l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.82 260.55l-.704 1.34.704-1.34m1.407 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M305.56 260.55l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M309.07 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M311.89 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M312.59 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M313.76 260.77l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M314.7 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M315.4 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M316.11 260.55l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M316.81 260.55l-2.11 3.347 3.517-3.347h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M190.18 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M190.89 261.22l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M199.33 261.22l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M200.03 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M200.73 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M202.85 261.22v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M204.96 261.22l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M205.66 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M208 261.66l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M208.47 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M209.88 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M210.58 261.22l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M211.29 261.22l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M211.99 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M213.63 261.66l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M215.74 261.66l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M231.69 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M232.39 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M233.1 261.22l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M233.8 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M234.5 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M235.21 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M249.28 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M251.39 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M252.09 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M252.79 261.22l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M257.72 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M258.42 261.22l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M259.12 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M272.49 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M273.19 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M273.9 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M274.6 261.22l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M275.31 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M276.01 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M290.08 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.78 261.22l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M291.49 261.22l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M292.19 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.71 261.22l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.82 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.93 261.22l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M304.85 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M308.37 261.22l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M311.18 261.22v.67h2.814v-.67h-2.814z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M314 261.22l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M314.7 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M315.4 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M317.52 261.22l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M190.18 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M191.12 262.33l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M191.59 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M192.29 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M195.11 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M198.62 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M199.33 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M200.73 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M201.44 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M202.85 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M205.66 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M206.36 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M208.47 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M209.18 261.89l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M209.88 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "M210.58 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M211.29 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M219.73 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M220.43 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M221.14 261.89l.703.67-.703-.67m13.366 0l.703.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M235.21 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M235.91 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M236.61 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M249.98 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M256.31 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "M257.01 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M254.2 262.56v.67h2.11c-5.4 8.378-1.462 19.627-.703 28.783h.704c1.97-8.2 2.16-19.985 0-28.114l2.814 1.338.704-2.677-.703-.67-4.925.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "M259.12 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M259.83 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M271.08 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M271.79 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M272.49 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M273.19 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M289.38 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.08 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M292.19 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.89 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295.71 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.82 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.93 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.63 261.89l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.85 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M307.67 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M311.18 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M312.59 261.89l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M313.53 262.33l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M314 261.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M314.7 261.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M316.81 261.89l-2.11 2.678 2.11-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M190.18 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M191.59 262.56l1.407 4.016h.703l.704-2.677-2.814-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M192.29 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M193 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M193.7 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M195.11 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M195.81 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M198.62 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M199.33 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M202.14 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M202.85 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M206.36 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "M207.07 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M207.77 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M210.58 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M213.16 262.78l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M215.51 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M216.92 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M217.62 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M218.32 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M219.03 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M219.73 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M220.43 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M221.14 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M249.98 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M252.79 262.56l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "M253.5 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M259.83 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M289.38 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.08 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.19 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.89 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.71 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.41 262.56l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.82 262.56l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.52 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.63 262.56l.703.67-.703-.67m1.407 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.74 262.56l.704.67-.704-.67m1.407 0l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.85 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.96 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M307.67 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M310.48 262.56l1.407 1.34-1.407-1.34zm3.52 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M317.52 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M318.22 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M318.92 262.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M319.63 262.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "M189.48 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M190.18 263.23l2.11 3.347-2.11-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M190.89 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M193.7 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M194.4 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M195.11 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M195.81 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M197.92 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M199.09 263.45l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M200.03 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b8c73",
    d: "M202.85 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M207.07 263.23l1.407 1.34v-1.34h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "M208.47 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M209.88 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M215.51 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M216.21 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M216.92 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M214.8 268.58l1.407-.67v.67l-4.924 4.016c4.37-1.655 6.58-3.93 8.44-8.032l-2.11 1.338 1.408-2.677-4.22 5.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M219.03 263.23l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M219.73 263.23l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M220.43 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M242.24 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "M242.94 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M243.65 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M244.35 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M245.06 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M245.76 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M249.98 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M251.39 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310010",
    d: "M252.79 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#180821",
    d: "M253.5 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310010",
    d: "M254.2 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M254.9 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M255.61 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M259.83 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M261.94 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M262.64 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M263.35 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c4a4a",
    d: "M264.05 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M265.46 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M289.38 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.19 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M292.89 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.41 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.82 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.63 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.38 263.67l.235.446-.235-.446m2.58-.446l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M312.59 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M316.81 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M317.52 263.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M319.63 263.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M320.33 263.23l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M189.71 264.34l.234.446-.234-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M190.89 263.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M191.59 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M194.4 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M195.11 263.89v.67l2.11.67-2.11-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M196.51 263.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M197.92 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M198.62 263.89v3.347h-.703l-.704-2.008h-.703l.703 6.693h-.703l-.704-7.364h-.703l-.704 5.354h-.704l-3.518-2.677 2.11 4.016h-.703l-2.814-3.347c2.364 7.92 5.74 6.83 11.362 11.28 2.092 1.654 3.414 5.24 4.82 7.464l-2.815-2.01 1.407 2.01-3.517-2.01 4.22 4.018.704-2.008h.705c-1.768 3.205-4.893 3.58-8.442 4.016v-.67l1.407-1.338 3.517.67c-2.53-2.53-5.68-2.957-9.145-2.01l4.22 3.348v.67l-4.22 4.685 8.442-1.338-.704 1.34h.704l4.22-2.01-8.44 4.017v.668c7.115-.874 7.968-3.24 11.958-8.032-.554 2.154-.553 3.365 1.407 4.685l-1.1-7.994 9.54-10.747-3.517 2.676 2.814-4.016c-3.983.784-5.715 3.588-5.628 7.363l-4.222 4.016h-.703c1.5-4.21 5.582-6.61 4.22-11.38-3.67 2.603-4.73 5.793-4.924 10.04l-2.813-13.388.704 2.678h-.703v-1.34h-.703l.703 9.373h-.703c-2.2-5.128-.277-15.42-4.925-18.743z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M200.03 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M203.08 264.34l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.96 263.89l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M209.18 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M209.88 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M215.51 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M216.21 263.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M219.73 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M245.06 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M245.76 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M246.46 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "M247.17 263.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M247.87 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M250.68 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M251.39 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M252.09 263.89l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M249.98 287.32h.704c-1.136-8.55-.665-15.642 3.517-23.43-8.294 4.046-7.8 16.764-4.22 23.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M254.2 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c2118",
    d: "M254.9 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "M257.72 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "M259.12 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M259.83 263.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M260.53 263.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5252",
    d: "M261.24 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M261.94 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M262.64 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M279.53 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M288.67 263.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M289.38 263.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M290.08 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.78 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.89 263.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.6 263.89l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M296.41 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.75 264.34l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.63 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.49 264.34l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.96 263.89l.703.67-.703-.67m2.814 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M314 263.89l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M315.4 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M316.11 263.89l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M316.81 263.89l.704.67-.704-.67m3.518 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M191.59 264.56l.703.67-.703-.67m2.814 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M196.04 265.01l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M197.22 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M197.92 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M200.03 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M204.96 264.56l.704.67-.704-.67m3.518 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M209.18 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M209.88 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M215.74 265.01l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M217.62 264.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M218.32 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M219.73 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M228.17 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M247.87 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M248.57 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M249.28 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M249.98 264.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M250.68 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M253.5 264.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5252",
    d: "M254.2 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M257.72 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M259.12 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M259.83 264.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M279.53 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M288.67 264.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M289.38 264.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M290.08 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M290.78 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.6 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.41 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.11 264.56l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.87 265.01l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.45 264.56l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.15 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.56 264.56l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M310.48 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M313.29 264.56l-2.814 3.347 2.814-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M314 264.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M314.7 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M315.4 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M316.11 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M317.52 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M318.22 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M318.92 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M319.63 264.56l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M321.27 265.01l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M321.74 264.56l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M189.71 265.68l.234.446-.234-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M190.18 265.23l.703.67-.703-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M192.29 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M194.17 265.46l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M197.22 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M197.92 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M200.03 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M200.73 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M202.85 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M203.55 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M205.66 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M209.18 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M212.69 265.23l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M217.62 265.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M219.03 265.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M219.73 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M228.17 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M228.87 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M229.58 265.23l.703.67-.703-.67m20.4 0l.705.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M250.68 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M252.79 265.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M253.5 265.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M254.2 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.72 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "M258.42 265.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M259.12 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#debdb5",
    d: "M278.12 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c4a4a",
    d: "M278.82 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M279.53 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "M280.46 265.68l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M288.67 265.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M289.38 265.23l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M291.49 265.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.6 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.3 265.23l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.11 265.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.52 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.22 265.23l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M303.68 265.68l.235.446-.235-.446m1.876-.446l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.78 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M310.48 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M313.29 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M314 265.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M314.7 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M316.81 265.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M317.52 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M319.63 265.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M320.33 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M321.74 265.23l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M322.44 265.23l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M186.66 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M187.84 266.13l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M188.78 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M190.18 265.9l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M192.29 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M193.7 265.9l-.703 2.008.703-2.008m2.11 0v2.008h.704l-.704-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M197.92 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M200.73 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M203.55 265.9l.703.67-.703-.67m2.814 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M209.18 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M212.69 265.9l.703.67-.703-.67m2.58.223l.468.223-.468-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M216.92 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M219.03 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M228.87 265.9v10.71h-.703l-.704-9.372h-6.33v19.412l2.813-1.338 1.407 4.685 3.517-2.008.704 7.362 6.33-2.008c2.962 2.01 4.85 2.025 6.333-1.34h1.407l4.22 4.018-.703-12.718-12.662-.67v-.67l11.96.67v-2.008c-8.865-.198-9.85-5.54-9.85-12.718l-7.738-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M229.58 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5252",
    d: "M230.28 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M230.99 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M249.98 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M250.68 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M252.79 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "M253.5 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M254.2 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M257.01 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M257.72 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "M258.42 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M276.71 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a56363",
    d: "M277.42 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M278.12 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M271.79 267.91c0 6.753-.655 12.3-9.145 12.718 1.878 5.082 10.972 1.852 13.994-.82 4.19-3.706 3.592-8.948 3.592-13.907l-8.442 2.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M287.97 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M288.67 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M291.49 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.3 265.9l.704.67-.704-.67m2.814 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.22 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M304.85 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M305.56 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.15 271.93l6.33-6.024c-3.48.84-4.903 3.057-6.33 6.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M309.07 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M312.59 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M313.29 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M314 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M316.11 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M316.81 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M320.33 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M321.03 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M321.74 265.9l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M322.44 265.9l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M323.14 265.9l.703.67-.703-.67m-136.48.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M187.37 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M188.54 266.8l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M189.71 267.02l.234.446-.234-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M190.18 266.57l.703.67-.703-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M192.29 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M197.92 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M200.73 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M203.55 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M206.36 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M209.18 266.57v2.008h.703l-.703-2.008m3.048.446l.235.446-.235-.446m2.58-.446l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M216.68 266.8l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M218.32 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M219.03 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M220.43 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "M227.47 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M230.99 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M231.69 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "M232.39 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M233.1 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M249.28 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M249.98 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M252.09 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M252.79 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "M253.5 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M257.01 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a2129",
    d: "M257.72 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M258.42 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6a5a5",
    d: "M274.6 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "M275.31 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a52921",
    d: "M276.01 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M276.71 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a2129",
    d: "M280.23 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M280.93 266.57v.67h6.33l-6.33-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M287.26 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M290.08 266.57l2.11 1.34v-.67l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M291.49 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.19 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M294.3 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295 266.57l-.704 1.34.704-1.34m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297.82 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.22 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.63 266.57l.703.67-.703-.67m1.407 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M303.45 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.85 266.57l.703.67-.703-.67m3.518 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M311.89 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M312.59 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M315.4 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M316.11 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M321.74 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M322.44 266.57l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M323.14 266.57l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M187.37 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M188.07 267.24l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M188.78 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M192.29 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M193.7 267.24l.704.67-.704-.67m5.16.446l.234.446-.235-.446m1.875-.446l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M201.44 267.24l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M204.25 267.24l.703.67-.703-.67m2.814 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M214.1 267.24l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M214.8 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M216.21 267.24l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M218.32 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M233.1 267.24l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M233.8 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M234.5 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "M235.68 267.46l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "M236.61 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M249.28 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M252.09 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M252.79 267.24l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "M253.5 267.24l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M256.31 267.24l1.407 6.024-1.407-6.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M257.01 267.24l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M257.72 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c69c94",
    d: "M271.08 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad3931",
    d: "M272.26 267.46l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M273.19 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M273.9 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M274.6 267.24l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M280.23 267.24v5.355h.704l-.704-5.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M280.93 267.24c0 12.41-7.252 16.998-19.698 16.065l-.704 12.718c2.66-.043 6.397.155 7.035-2.678l2.815 2.01 2.814-2.68-.704 2.68 1.407-1.34h.704l4.22-.67-.704 2.01 2.11-2.68 1.408 1.34h2.11v-2.008l1.407.67.705-6.025c3.57-2.97 1.407-14.982 1.407-19.412h-6.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M290.08 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.19 267.24l.703.67-.703-.67m2.814 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.82 267.24v2.008h.703l-.703-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.22 267.24l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.33 267.24v3.347h.703l-.703-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.15 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M304.85 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M307.67 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.18 267.24l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M311.89 267.24l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M314.7 267.24l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M315.4 267.24l.703.67-.703-.67m-127.33.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M189.48 267.91l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M190.18 267.91l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M193 267.91l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M193.7 267.91l.704.67-.704-.67m2.11 0v1.34h1.407v-1.34h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M201.44 267.91l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M204.25 267.91l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M215.51 267.91l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M217.62 267.91l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M218.32 267.91l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.61 267.91v6.024h.703l-.703-6.024z",
    fillOpacity: 0.475,
    fill: "#8c7373"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M248.57 267.91l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M249.28 267.91l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M252.09 267.91l.703.67-.7-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M253.5 267.91l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M257.01 267.91l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M290.08 267.91l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M290.78 267.91l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M292.19 267.91l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295 267.91l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.22 267.91l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.45 267.91l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.15 267.91l.703.67-.703-.67m2.814 0l.703.67-.703-.67m2.814 0l-3.518 4.016 3.518-4.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M310.48 267.91l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M311.18 267.91l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M314.7 267.91l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M188.07 268.58l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M188.78 268.58l.703.67-.703-.67m2.11 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M193.93 269.03l.235.446-.235-.446m4.925 0l.234.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M201.44 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M204.25 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M204.96 268.58l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M209.18 268.58l.703.67-.703-.67m4.22.67v.67h2.112l-2.11-.67m2.11-.67l.703.67-.704-.67m1.41 0l.702.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M217.62 268.58l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M242.71 268.8l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M243.65 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M244.35 268.58l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M245.06 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M248.57 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M249.28 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M251.39 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M252.09 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M253.5 268.58l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M257.01 268.58l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "M257.72 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M258.42 268.58l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M262.64 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M263.35 268.58l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M264.52 268.8l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M265.46 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M290.08 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M290.78 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M291.49 268.58l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M292.19 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.89 268.58l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295.47 268.8l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.52 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.22 268.58l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.93 268.58l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M303.45 268.58l.703.67-.703-.67m2.814 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M314.7 268.58l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M188.78 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M190.89 269.25l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M196.75 269.7l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M201.44 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M203.55 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M204.96 269.25l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M205.66 269.25l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M208.71 269.7l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M214.1 269.25l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M216.92 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M242.94 269.25c.042 3.358.415 5.073 4.22 5.355.59-3.62-.563-4.587-4.22-5.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M244.35 269.25l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M245.06 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M245.76 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M246.46 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M247.17 269.25l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M247.87 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M248.57 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M251.39 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M252.79 269.25l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M253.5 269.25l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M257.01 269.25l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "M257.72 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M258.42 269.25l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M260.53 269.25l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M261.24 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M261.94 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M262.64 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M263.35 269.25l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M259.12 270.59c1.647 5.808 6.266 3.942 6.33-1.34l-6.33 1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M290.08 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.78 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M291.49 269.25l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M292.19 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M292.89 269.25l.704.67-.704-.67m2.814 0l.704.67-.704-.67zm9.856 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M309.07 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M313.29 269.25l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M314 269.25l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M188.78 269.92l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M190.89 269.92l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M191.59 269.92l.703.67-.703-.67m2.814 0l.703.67-.703-.67m4.22 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M203.55 269.92l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M205.66 269.92l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M212.69 269.92l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M216.21 269.92l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M216.92 269.92l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M247.17 269.92l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M247.87 269.92l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M248.57 269.92l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M251.39 269.92l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b5adad",
    d: "M252.79 269.92l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M257.01 269.92l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M257.72 269.92l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "M258.42 269.92l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M259.12 269.92l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M259.83 269.92l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M260.53 269.92l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M290.78 269.92l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M291.49 269.92l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M292.19 269.92l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M292.89 269.92l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.71 269.92l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.41 269.92l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.75 270.37l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.22 269.92l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.85 269.92l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M308.37 269.92l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M312.59 269.92l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M188.78 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M191.59 270.59l.703.67-.703-.67m3.048.446l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M196.51 270.59l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M204.25 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M207.77 270.59l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M208.47 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M211.99 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M247.87 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M248.57 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M250.68 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M251.39 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "M257.72 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#390821",
    d: "M258.42 270.59l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M290.78 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M291.49 270.59l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M292.19 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M292.89 270.59l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.6 270.59l.703.67-.703-.67m2.11 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.93 270.59l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.33 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.15 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.67 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M311.89 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M312.59 270.59l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M188.78 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M189.48 271.26l.703.67-.703-.67m2.814 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M196.51 271.26l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M202.85 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M204.25 271.26l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M204.96 271.26l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M207.77 271.26l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M210.58 271.26l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M211.29 271.26l.704.67-.704-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M214.1 271.26l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M214.8 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M215.51 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M247.87 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M250.68 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "M257.01 271.26l.704.67-.704-.67m1.407 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M289.14 271.48l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M290.78 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.95 271.48l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M292.89 271.26l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M293.6 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.64 271.7l.235.446-.235-.446m2.11 0l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.93 271.26l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M303.45 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.96 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M311.18 271.26l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M311.89 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M314.7 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M315.4 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M316.11 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M316.81 271.26l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M317.52 271.26l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M189.48 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M192.29 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M194.4 271.93l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M195.11 271.93l.703.67-.703-.67m3.518 0l-.704 1.34h1.407l-.702-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M201.44 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M203.08 272.37l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M207.07 271.93l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M207.77 271.93l.704.67-.704-.67m2.345.446l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M210.58 271.93l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M211.99 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M212.69 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M213.4 271.93l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M247.87 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M250.68 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M257.95 272.37l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "M258.42 271.93l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M259.12 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M288.67 271.93l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M289.38 271.93l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M290.78 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M291.49 271.93l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.89 271.93l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M293.6 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.33 271.93v2.678h.703l-.703-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.21 272.15l.47.224-.47-.224m2.345-.223l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.26 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M310.48 271.93l-1.407 3.347h.703l.704-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M311.18 271.93l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M313.29 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M314 271.93l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M314.7 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M315.4 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M317.52 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M318.22 271.93l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M189.48 272.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M192.76 272.82l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M201.44 272.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.02 272.82l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M205.66 272.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M207.07 272.6l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M209.18 272.6v2.008l2.11-2.008h-2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M211.29 272.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M211.99 272.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M242.24 272.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M247.63 272.82l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M250.68 272.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M258.66 273.04l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#390821",
    d: "M259.12 272.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M280.23 272.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M289.38 272.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M291.49 272.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.89 272.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M293.6 272.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.3 272.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M296.88 272.82l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.52 272.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M302.74 272.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M310.48 272.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M311.18 272.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M311.89 272.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M312.59 272.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M313.29 272.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M318.22 272.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M189.48 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M190.18 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M193 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M195.11 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M197.92 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M201.44 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M202.85 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M204.49 273.71l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M207.07 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M209.18 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M210.58 273.27l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M211.99 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M212.69 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M220.43 273.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M227.47 273.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M242.24 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M249.98 273.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M250.68 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M257.01 273.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M257.72 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "M259.12 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M265.46 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M280.46 273.71l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M289.38 273.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M290.08 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M291.49 273.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.07 273.49l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.11 273.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.22 273.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M309.78 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M310.48 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M311.18 273.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M311.89 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M318.22 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M318.92 273.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M190.18 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M193 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M195.11 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M195.81 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M197.92 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M201.67 274.38l.235.446-.235-.446m1.173-.446l.703.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M206.36 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M207.07 273.94l-.703 3.347h.703v-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M208.71 274.38l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M211.29 273.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M212.23 274.38l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M212.69 273.94l.703.67-.703-.67m5.628 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M219.03 273.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M219.73 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M220.43 273.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M228.17 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "M236.61 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M242.24 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M242.94 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M249.98 273.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M250.68 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M257.01 273.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "M257.72 273.94l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "M258.89 274.16l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M259.83 273.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M264.75 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M265.46 273.94l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M289.38 273.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M290.08 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M291.49 273.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.19 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.3 273.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.11 273.94l.704.67-.704-.67zm7.04 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M309.07 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M309.78 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M310.48 273.94l.703.67-.703-.67m6.097.223l.47.223-.47-.223m1.642-.223l.702.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M318.92 273.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M190.18 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M190.89 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M193.7 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M195.81 274.6l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M196.51 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M197.92 274.6l-.703 2.008.703-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M202.85 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M203.55 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M204.96 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#738c63",
    d: "M209.18 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M210.58 274.6l-2.814 3.347 2.814-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M211.29 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M212.93 275.05l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M215.51 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M216.21 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M216.92 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M217.62 274.6v2.008h.704l-.704-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M218.79 274.83l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M219.73 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M220.43 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M228.17 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "M236.61 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M242.94 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M243.65 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M244.35 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M245.52 274.83l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M246.46 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M249.98 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M250.68 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M257.01 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "M257.72 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M259.12 274.6l2.814 7.363-2.814-7.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "M259.83 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M260.53 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M261.24 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M264.05 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c4a42",
    d: "M271.08 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M279.53 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M289.61 275.05l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M290.08 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M291.49 274.6l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.19 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M294.3 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.11 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M303.45 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M307.9 275.05l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M308.37 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M314.7 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M315.4 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M316.11 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M316.81 274.6l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M317.52 274.6l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M318.92 274.6l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M190.89 275.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M191.59 275.27l1.407 1.34-1.407-1.34m2.11 0l2.11 1.34v-.67l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M194.4 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M197.22 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M201.44 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M202.85 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M203.55 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M204.96 275.27v2.008h.704l-.704-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M207.77 275.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M208.47 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M209.18 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M210.58 275.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M211.99 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M214.1 275.27l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M214.8 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M215.51 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M219.03 275.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M219.73 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M228.17 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M236.61 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M246.46 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M247.17 275.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M249.98 275.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M252.79 275.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M257.01 275.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M258.66 275.72l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "M259.83 275.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M260.53 275.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad3931",
    d: "M271.08 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M279.53 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.08 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.19 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M294.77 275.5l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.22 275.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.26 275.27l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.96 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M313.29 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M314 275.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M314.7 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M317.52 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M318.92 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M319.63 275.27l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M324.55 275.27l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M325.49 275.72l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M191.59 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M197.92 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M200.73 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M201.44 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M203.55 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M207.77 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdc6ad",
    d: "M208.47 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M209.88 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M211.29 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M212.93 276.39l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M214.1 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M218.32 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M219.03 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M228.17 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M236.61 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a59494",
    d: "M237.32 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M246.46 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M247.17 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M249.98 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "M252.79 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M253.73 276.39l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "M259.83 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M260.53 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#debdb5",
    d: "M270.38 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M271.08 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M279.53 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a7b42",
    d: "M289.38 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.08 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M290.78 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M292.19 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.3 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295 275.94v2.008h.703L295 275.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.05 276.39l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.22 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.04 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M305.56 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.26 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M311.89 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M312.59 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M313.29 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M318.22 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M318.92 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M319.63 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M322.44 275.94l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M323.14 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M323.85 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M324.55 275.94l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M192.29 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M193 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M197.92 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M198.86 277.06l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M201.44 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M203.55 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M207.07 276.61l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M207.77 276.61l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M209.18 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M211.29 276.61l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M213.4 276.61l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M216.92 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M217.62 276.61l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M219.03 276.61l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M228.87 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M237.32 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M246.46 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M249.98 276.61v5.355h.704l-.704-5.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M252.79 276.61l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M257.01 276.61l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "M259.12 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M260.53 276.61l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c4239",
    d: "M270.38 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M278.82 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M287.97 276.61l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M289.61 277.06l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M290.78 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M292.19 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.33 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M302.04 276.61l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.85 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M305.56 276.61l.704.67-.704-.67m4.925 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M311.18 276.61l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M311.89 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M318.92 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M319.63 276.61l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M320.33 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M321.03 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M321.74 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M322.67 277.06l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M323.14 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M323.85 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M324.55 276.61l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M193 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M193.7 277.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M194.4 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M195.11 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M201.44 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M203.55 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M207.07 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M208.47 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M210.58 277.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M211.29 277.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M212.69 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M213.4 277.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M216.21 277.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M216.92 277.28l.703.67-.703-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M219.03 277.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M228.87 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M237.32 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M238.02 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M246.46 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M252.79 277.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M253.5 277.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "M257.72 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "M258.42 277.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "M259.12 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "M260.53 277.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M261.24 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a5847b",
    d: "M269.68 277.28l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M270.38 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "M278.82 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M287.97 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.78 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M291.49 277.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M292.19 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.05 277.73l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.63 277.28l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.33 277.28l.703.67-.703-.67m2.814 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.07 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M309.78 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M310.48 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M316.58 277.51l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M317.52 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M318.22 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M318.92 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M319.63 277.28l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M320.33 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M321.03 277.28l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M321.74 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M323.14 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M323.85 277.28l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M195.11 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M195.81 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M196.51 277.95l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M197.22 277.95l.703.67-.703-.67m2.11 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M201.44 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M206.36 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M207.07 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M207.77 277.95l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M210.58 277.95l.704.67-.704-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M215.51 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M216.21 277.95l.704.67-.704-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M229.58 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M238.02 277.95l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a59494",
    d: "M238.72 277.95l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M253.5 277.95l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M258.42 277.95v9.371h2.11l-2.11-9.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M259.36 278.4l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "M260.53 277.95l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M261.24 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M269.68 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M278.12 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M287.97 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M288.67 277.95l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M289.38 277.95l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.78 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M291.49 277.95l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "M292.42 278.4l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.71 277.95l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.63 277.95l.703.67-.703-.67m2.11 0l-2.11 2.678 2.11-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M303.45 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.67 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M308.37 277.95l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M309.07 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M309.78 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M310.48 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M311.65 278.17l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M312.59 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M313.29 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#426331",
    d: "M314 277.95l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M314.7 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M315.4 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M316.58 278.17l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M321.03 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M321.74 277.95l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M322.44 277.95l.704.67-.704-.67m-125.22.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M197.92 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M198.62 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M199.33 278.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M200.03 278.62l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M201.44 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M202.14 278.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M206.36 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M207.07 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M207.77 278.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M209.88 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M212.69 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M215.51 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M218.32 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M229.58 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M230.28 278.62l1.407 2.008-1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "M239.43 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M240.13 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M253.5 278.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M257.95 279.07l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2131",
    d: "M261.24 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "M268.27 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M268.97 278.62l.704.67-.704-.67m8.442 0l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M278.12 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M287.97 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M288.67 278.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M289.38 278.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M291.49 278.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.94 279.07l.235.446-.235-.446m1.876-.446l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.26 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.96 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M307.67 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M308.37 278.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M309.07 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M309.78 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M310.48 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M318.92 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M319.63 278.62l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M320.33 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M321.03 278.62l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M197.92 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M198.62 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M200.03 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M202.14 279.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M205.66 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M206.36 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M207.07 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M209.65 279.51l.47.224-.47-.224m2.814 0l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M214.8 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M217.62 279.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M218.32 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M240.13 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "M240.83 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M241.54 279.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "M253.73 279.74l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "M259.12 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "M259.83 279.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "M261.24 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M261.94 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a5847b",
    d: "M266.86 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c2118",
    d: "M267.57 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M277.42 279.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M288.2 279.74l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M288.67 279.29v.67h2.11v-.67h-2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M289.38 279.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.49 279.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M292.19 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.82 279.29l.703.67-.703-.67m7.738 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M306.26 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M306.96 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M317.52 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M318.22 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M318.92 279.29l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M319.63 279.29l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M197.92 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M200.73 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M202.14 279.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M202.85 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M205.66 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M207.07 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M209.18 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M211.99 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M214.1 279.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M214.8 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M217.62 279.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M218.32 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M231.69 279.96l.703.67-.703-.67m9.85 0l.702.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c2929",
    d: "M242.24 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "M242.94 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a59494",
    d: "M243.65 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "M244.35 279.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "M245.52 280.18l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M246.46 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M257.72 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "M259.12 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M259.83 279.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "M261.24 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M261.94 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "M262.64 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd8c8c",
    d: "M263.35 279.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a5847b",
    d: "M264.05 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c5a52",
    d: "M264.75 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad3931",
    d: "M265.46 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M266.16 279.96l.704.67-.704-.67m9.85 0l.702.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M276.71 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M288.67 279.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M290.31 280.41l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.49 279.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M292.19 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295.71 279.96v2.008h.704l-.704-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.85 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M315.4 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M316.11 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M316.81 279.96l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M317.52 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M318.22 279.96l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M197.92 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M198.62 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M200.03 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M200.73 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M202.85 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M205.66 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M206.36 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M207.07 280.63l.703.67-.703-.67m2.11 0l.704.67-.704-.67m2.11 0l-1.406 2.678h.703l.704-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M211.99 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M213.87 280.85l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M216.92 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M217.62 280.63l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M231.69 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M232.39 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M246.46 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "M253.5 280.63l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M257.95 281.08l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M259.83 280.63l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M261.94 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M275.31 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M276.01 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M288.67 280.63l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M292.19 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.63 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M303.45 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.15 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M314 280.63l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M314.7 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M315.4 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M316.11 280.63l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M198.62 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M199.33 281.3l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M200.03 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M200.73 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M201.44 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M202.85 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M203.55 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M205.66 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M206.36 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M207.07 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M211.29 281.3l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M212.69 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M213.4 281.3l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M216.92 281.3l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M233.1 281.3l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M233.8 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M246.46 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "M253.5 281.3l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M259.83 281.3l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M261.94 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M273.9 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#291029",
    d: "M274.6 281.3l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29396b",
    d: "M287.26 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M288.67 281.3l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M290.08 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.78 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.19 281.3l.703.67-.703-.67m10.552 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.45 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.07 281.3l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M309.78 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M310.48 281.3v.67h2.814l-2.814-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M313.29 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M314 281.3l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M314.7 281.3v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M316.81 281.3v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b8c73",
    d: "M318.92 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M319.63 281.3l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M320.33 281.3l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M198.62 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M201.44 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M203.55 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M204.96 281.97l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M205.66 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M206.36 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M211.29 281.97l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M211.99 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M216.92 281.97l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M234.5 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M235.21 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M235.91 281.97l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M246.46 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M247.17 281.97l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425a84",
    d: "M249.98 281.97l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b5adad",
    d: "M253.5 281.97l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M257.72 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "M260.3 282.19l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "M261.24 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M261.94 281.97l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M271.79 281.97l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M272.49 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M273.19 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M287.26 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396321",
    d: "M288.67 281.97l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M290.78 281.97v2.008h.703l-.703-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.19 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.89 281.97l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295.71 281.97v3.347h1.407l-1.407-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.41 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M302.04 281.97l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.74 281.97l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M307.9 282.41l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M308.37 281.97l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M309.07 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M318.92 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M319.63 281.97l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M320.33 281.97l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M198.62 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M199.33 282.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M200.03 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M201.44 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M202.14 282.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.49 283.08l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M204.96 282.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M205.89 283.08l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M206.6 283.08l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M209.18 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M214.8 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "M220.43 282.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M235.91 282.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M237.32 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M238.02 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M238.72 282.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M239.43 282.64v.67h5.628l-5.628-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M245.06 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M245.76 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M246.46 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M247.17 282.64l.704.67-.704-.67m3.05.446l.233.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M253.5 282.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M254.43 283.08l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M260.53 282.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M261.24 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080829",
    d: "M261.94 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M263.35 282.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M268.97 282.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M269.68 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1021",
    d: "M270.38 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M271.08 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M287.26 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a7b42",
    d: "M288.67 282.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.89 282.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.04 282.64l.704.67-.704-.67m3.518 0l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M306.26 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.96 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M315.4 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M316.11 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M316.81 282.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M317.52 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M318.22 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M318.92 282.64l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M319.63 282.64l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M198.62 283.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M199.33 283.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M200.03 283.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M200.73 283.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M201.44 283.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M202.14 283.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M204.96 283.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M208.94 283.53l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M214.1 283.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M239.43 283.31l.703.67-.703-.67zm4.92 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "M247.17 283.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M253.5 283.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#291029",
    d: "M260.53 283.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M264.05 283.31v.67h4.924l-4.924-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M287.26 283.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M287.97 283.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M288.91 283.75l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.13 283.75l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.33 283.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.85 283.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M305.56 283.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M311.89 283.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M312.59 283.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M313.29 283.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M314 283.31l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M314.7 283.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M315.4 283.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M316.11 283.31l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M198.62 283.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M199.33 283.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M200.03 283.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M200.73 283.98l1.407 1.34v-1.34h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M202.14 283.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M202.85 283.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M204.96 283.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M205.66 283.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M206.36 283.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M208.47 283.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M212.69 283.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M213.4 283.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M214.1 283.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M247.17 283.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M247.87 283.98l.703.67-.703-.67m2.11 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M250.68 283.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M254.2 283.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#390821",
    d: "M260.53 283.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M287.26 283.98l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M287.97 283.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.78 283.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.49 283.98l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.22 285.98l2.11-2.008-2.11 2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.45 283.98l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.15 283.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M304.85 283.98l.703.67-.703-.67m5.628 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M311.18 283.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M311.89 283.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M312.59 283.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M190.89 284.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M191.59 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M199.33 284.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M200.73 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M202.85 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M203.55 284.65l.703 2.008h.704l-1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M205.66 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M206.36 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M208.24 284.87l.47.224-.47-.224m2.345-.223l.704.67-.705-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M211.29 284.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M211.99 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M212.69 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "M247.87 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M249.98 284.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M250.68 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M254.2 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M257.72 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M260.53 284.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M288.67 284.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M291.49 284.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.89 284.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.6 284.65l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M302.74 284.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M303.45 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M309.07 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M309.78 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M310.48 284.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M190.89 285.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M191.59 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M192.29 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M193 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M193.7 285.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M199.33 285.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M201.44 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M202.14 285.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M203.55 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M207.77 285.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M209.88 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M210.58 285.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M211.99 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M212.69 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M218.32 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M219.03 285.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M223.25 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M248.57 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M250.68 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "M254.43 285.76l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M257.72 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M287.97 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M288.67 285.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.72 285.76l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M293.6 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.18 285.54l.47.224-.47-.224m2.345-.223l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.04 285.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M302.74 285.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.67 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M308.37 285.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M309.07 285.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M190.89 285.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M191.59 285.98l.703.67-.703-.67zm2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M194.87 286.21l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M195.81 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M196.51 285.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M197.22 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M197.92 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M198.62 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M199.33 285.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M200.03 285.98l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M202.14 285.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M202.85 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M207.77 285.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M209.18 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M209.88 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M211.99 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M212.69 285.98v2.678h.703l-.703-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M213.4 285.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M218.32 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M219.03 285.98l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M219.73 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M222.54 285.98l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M223.25 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M248.57 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M249.28 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M250.68 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M257.72 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M287.97 285.98v2.008h.703l-.703-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M288.67 285.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.83 286.43l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.22 287.99l3.518-2.008-3.518 2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.33 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.96 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M307.67 285.98l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M308.37 285.98l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M191.59 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M197.92 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M198.62 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M200.03 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M200.73 286.65l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M203.55 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M204.96 286.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M209.18 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M211.29 286.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M211.99 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M212.69 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M214.1 286.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M218.32 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M219.03 286.65c-2.28 4.675-4.734 9.722 1.407 12.718 0-3.93 1.482-9.69-1.407-12.718z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M221.14 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M222.54 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M223.25 286.65l-.703 1.34h1.407l-.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M223.95 286.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "M249.28 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M250.68 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "M254.43 287.1l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M257.72 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M286.09 287.1l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M286.56 286.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M287.26 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M288.67 286.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M291.49 286.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.41 286.65l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.63 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.56 286.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.26 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M306.96 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M307.67 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M308.84 286.88l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M310.25 286.88l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "M311.18 286.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M311.89 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M312.59 286.65v.67h3.518l-3.518-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M316.11 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M316.81 286.65l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M317.52 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M318.22 286.65l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M318.92 286.65l.703.67-.703-.67m-127.33.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M193.7 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M194.87 287.55l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M196.04 287.77l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M200.73 287.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.96 287.32l-.703 2.008h.703v-2.008m3.518 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M209.18 287.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M211.29 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M211.99 287.32c-1.65 4.31-1.22 6.867 1.407 10.71h.704v-10.71h-.703v8.033h-1.407v-8.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M214.1 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M217.62 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M218.32 287.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M220.43 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M221.84 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M223.95 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M249.28 287.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M249.98 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M250.68 287.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M257.72 287.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5252",
    d: "M258.42 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M259.12 287.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#290018",
    d: "M259.83 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M260.53 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M286.56 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M287.26 287.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M288.67 287.32l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M289.38 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.49 287.32v2.008h.704l-.704-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M293.6 287.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.93 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.45 287.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M304.15 287.32v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.73 287.55l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.67 287.32l.703.67-.703-.67m4.925 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M313.29 287.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M314 287.32l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M314.7 287.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M315.4 287.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M316.11 287.32l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M192.29 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M201.44 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M204.96 287.99l.704.67-.704-.67m3.518 0l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M209.18 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M210.58 287.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M211.29 287.99l.704.67-.704-.67m2.814 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M214.8 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M217.62 287.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M219.26 288.44l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M220.43 287.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M221.14 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M221.84 287.99l-.703 10.71 2.11-2.008h.704l-.703 2.677c5.504-1.57 6.518-5.128 4.925-10.042l-3.518 7.364h-.703v-8.702h-.703l-1.407 7.363v-7.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M222.54 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M223.95 287.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M227.47 287.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M228.17 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M249.98 287.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080829",
    d: "M250.68 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "M254.2 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M257.01 287.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M257.72 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M286.56 287.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M287.26 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M288.44 288.22l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.6 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.71 287.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.22 287.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M302.04 287.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M302.74 287.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.45 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.78 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M310.48 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M311.18 287.99l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M311.89 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M312.59 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M313.29 287.99l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M192.29 288.66l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M193 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M202.14 288.66l1.407 1.34v-1.34h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M203.55 288.66l.703.67-.703-.67m2.814 0l-.703 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M207.07 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M208.47 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M210.58 288.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M212.69 288.66v3.347h.703l-.703-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M214.8 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M216.92 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M217.62 288.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M221.14 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M222.54 288.66v2.678h.703l-.703-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M223.95 288.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M224.65 288.66l.704.67-.704-.67m2.11 0l-.703 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M227.47 288.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M228.17 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M249.98 288.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M250.68 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M251.39 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M257.01 288.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M287.26 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M287.97 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M289.38 288.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M293.6 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.71 288.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M300.63 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.33 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M302.04 288.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.67 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M308.37 288.66l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M309.07 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M309.78 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M310.48 288.66l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M311.65 288.89l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M193.7 289.33l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M199.56 289.78l.235.446-.235-.446m9.614-.446l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M209.88 289.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M210.58 289.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M215.04 289.78l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M216.21 289.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M216.92 289.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M219.03 289.33l.704.67-.704-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M224.65 289.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M226.76 289.33l.704.67-.704-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M228.87 289.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M250.68 289.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M251.62 289.78l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M257.01 289.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M287.26 289.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M287.97 289.33l.703.67-.703-.67m1.407 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M291.49 289.33l.704 2.678h.703l-1.407-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.19 289.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.6 289.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295 289.33l.703.67-.703-.67zm4.22 0l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.93 289.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.63 289.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.56 289.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.26 289.33v.67l2.814.67V290l-2.814-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.96 289.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M307.67 289.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M308.37 289.33v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M310.71 289.78l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M311.18 289.33v.67l2.814.67V290l-2.814-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M312.59 289.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M313.29 289.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M314 289.33l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M314.7 289.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M315.4 289.33l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M193.7 290l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M197.69 290.22l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M198.62 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M204.96 290l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M209.88 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M216.21 290l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M219.26 290.45l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M220.9 290.22l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M224.65 290l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M225.36 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M226.06 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.17 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M228.87 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M252.09 290l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M256.31 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M257.01 290l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M287.26 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M287.97 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M289.38 290l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.08 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M293.6 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.22 290l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.45 290l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.15 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.85 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M306.02 290.22l.47.224-.47-.224m3.048-.223l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M310.01 290.45l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M311.18 290l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M311.89 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M314 290l.704.67L314 290z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M314.7 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M315.4 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.11 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M316.81 290l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M317.52 290l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M194.64 291.12l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M195.11 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M195.81 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M196.51 290.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M204.25 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.96 290.67l.704.67-.704-.67m3.283.223l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M210.11 291.12l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M214.8 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M215.51 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M216.21 290.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M220.43 290.67v2.008h.704l-.704-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M224.65 290.67v1.34h1.407l-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M225.36 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M227.47 290.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M228.87 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M252.09 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c2118",
    d: "M256.31 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M285.86 290.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M286.56 290.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M288.2 291.12l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M289.84 290.89l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.82 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M302.27 291.12l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M303.21 290.89l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M295 298.7c6.744-3.558 11.844-6.024 19.698-6.024-6.507-3.734-17.534-1.503-19.698 6.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.07 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M310.48 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M311.18 290.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M311.89 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M312.59 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M313.29 290.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M195.11 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M201.44 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M202.14 291.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M203.55 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M204.25 291.34l.703.67-.703-.67m3.518 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M214.8 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M215.51 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M218.79 291.56l.47.224-.47-.224m3.752-.223v2.008h.703l-.703-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M226.76 291.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M228.87 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M252.09 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M252.79 291.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "M256.31 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M285.15 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M285.86 291.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a7b42",
    d: "M286.56 291.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M290.08 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.49 291.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.63 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.33 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M312.59 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M313.29 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M314 291.34l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M314.7 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M315.4 291.34l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M193.7 292.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M194.4 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M200.03 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M200.73 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M201.44 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M203.55 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M208 292.46l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M209.88 292.01l.703.67-.703-.67m2.814 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M215.27 292.23l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M218.32 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M224.89 292.46l.235.446-.235-.446m2.11 0l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.87 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M242.24 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M242.94 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M252.79 292.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M256.31 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M283.75 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.15 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M285.86 292.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396321",
    d: "M286.56 292.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M287.97 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M288.67 292.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.08 292.01l.703.67-.703-.67m2.11 0l.704.67-.704-.67m3.518 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.22 292.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.93 292.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M300.63 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M314.7 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M315.4 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M316.11 292.01l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M316.81 292.01l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M193.7 292.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M197.92 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M199.09 292.9l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M200.03 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M202.85 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M210.11 293.12l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M211.99 292.68v2.678h1.407v-2.678h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M214.8 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M215.51 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M218.32 292.68v3.347h.703l-.703-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M220.67 293.12l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M242.24 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M242.94 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M252.79 292.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M253.5 292.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M254.2 292.68l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "M254.9 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M255.61 292.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M271.79 292.68l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M272.73 293.12l.235.446-.235-.446m7.504-.446l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M280.93 292.68l2.814 2.008v-.67l-2.814-1.338z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M283.75 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M284.45 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M285.15 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M285.86 292.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M286.8 293.12l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M288.44 292.9l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M290.08 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.49 292.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.19 292.68l-.704 2.678.704-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.3 292.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M295.24 293.12l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.71 292.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.11 293.35v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.52 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.22 292.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.96 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M307.67 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M308.37 292.68l-1.407.67v.67l1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M309.07 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M309.78 292.68v.67h4.925l-4.925-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "M314.7 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M315.4 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M316.11 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M316.81 292.68l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M317.52 292.68l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M318.22 292.68l.703.67-.703-.67m-125.22.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M193.7 293.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M196.51 293.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M197.22 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M197.92 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M202.14 293.35l.704.67-.704-.67m5.628 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M214.1 293.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M214.8 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M215.51 293.35l.703.67-.703-.67m7.035 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M224.42 293.57l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M226.76 293.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M235.91 293.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M241.54 293.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M242.24 293.35l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M242.94 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M243.65 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "M254.2 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M254.9 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M255.61 293.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M267.57 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M271.79 293.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M277.42 293.35l1.407 1.34v-1.34h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M280.23 293.35l.704.67-.704-.67m2.11 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M283.75 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.45 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M285.15 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M285.86 293.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.31 293.79l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.6 293.35v.67l3.518 1.338v-.67l-3.518-1.338z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.3 293.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295.71 293.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.82 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M304.85 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.02 293.57l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M308.37 293.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M309.07 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M309.78 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M310.48 293.35l.703.67-.703-.67m5.628 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M316.81 293.35l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M317.52 293.35l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M318.69 293.57l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M193 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M195.11 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M195.81 294.02l.703.67-.703-.67m5.628 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M202.14 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M204.25 294.02l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.96 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M207.07 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M207.77 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M208.47 294.02l.703.67-.703-.67m1.876.223l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M214.1 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M214.8 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#426331",
    d: "M215.51 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M220.67 294.46l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M222.54 294.02l.703.67-.703-.67m1.407 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M226.53 294.24l.47.224-.47-.224m2.345-.223l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M235.21 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M235.91 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M236.61 294.02l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M240.83 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M241.54 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M242.24 294.02l-1.407 4.016-2.11-1.338 2.11 5.355h.703v-2.678h.704v4.686c3.403-2.147 2.963-5.962 2.11-9.37h-.703v6.693h-.703l-.704-7.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M243.65 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M244.35 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M253.5 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "M254.2 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M254.9 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M267.57 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M268.27 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M270.38 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M271.08 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M271.79 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M273.9 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M277.42 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M280.23 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M283.75 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M284.45 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M285.15 294.02l-4.22 12.05c4.018-2.114 6.002-8 4.22-12.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M285.86 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M286.56 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.6 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.18 294.24l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.11 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M302.74 294.02l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.74 294.69v.67h3.518l-3.518-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.85 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M305.56 294.02v.67h4.925l-4.925-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M310.48 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M311.18 294.02l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M311.89 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M312.59 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M318.92 294.02l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M192.29 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M193 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M194.4 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M195.11 294.69l.703.67-.703-.67m4.925 0v2.008h.703l-.704-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M200.73 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M204.25 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M207.07 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M208.47 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M210.58 294.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M214.1 294.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M215.51 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M222.31 294.91l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M224.18 295.13l.235.446-.235-.446m1.876-.446l.703.67-.704-.67m2.814 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M235.21 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.91 294.69l1.407 3.347h2.11l-3.517-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M236.61 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M240.83 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M242.94 294.69v2.678h.703l-.703-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M244.35 294.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M253.5 294.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M254.2 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M254.9 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083121",
    d: "M267.57 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M268.27 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M268.97 294.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M270.38 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M271.08 294.69l-.703 6.024h.703v-6.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083121",
    d: "M271.79 294.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M273.9 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M276.71 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M277.42 294.69l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M279.53 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M280.23 294.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M280.93 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M281.64 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M282.34 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M283.04 294.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M283.75 294.69l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M284.45 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M285.86 294.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M286.56 294.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M290.31 295.13l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.6 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.33 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M302.04 294.69l.704.67-.704-.67m4.22 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M306.96 294.69v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M309.54 294.91l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M311.18 294.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M311.89 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M312.59 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M313.29 294.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M314 294.69l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M192.29 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M197.22 295.36l.703 2.678h.704l-1.407-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M199.09 295.58l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M202.14 295.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M202.85 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M203.55 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M206.36 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M207.07 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M208.47 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M209.18 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M209.88 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M210.58 295.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M211.29 295.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M214.1 295.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M215.51 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M220.43 295.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M226.06 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M228.87 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M229.58 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313918",
    d: "M235.21 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M235.91 295.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M237.32 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M238.02 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M239.19 295.58l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "M240.13 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M240.83 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M244.35 295.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M245.06 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M253.5 295.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M254.2 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M264.05 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M264.75 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103921",
    d: "M267.57 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M268.27 295.36l-.703 8.702c2.614-2.436 2.55-5.768.703-8.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102121",
    d: "M268.97 295.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M269.68 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M270.38 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M271.79 295.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M272.49 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M273.19 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M273.9 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M274.6 295.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M275.77 295.58l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M277.65 295.8l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M278.12 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M278.82 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M279.53 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M280.93 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M281.64 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M282.34 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M283.75 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M284.45 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M291.49 295.36l.704.67-.704-.67m1.407 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.6 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.93 295.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.63 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.33 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.67 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M308.37 295.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M309.07 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M309.78 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M310.48 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M311.89 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M312.59 295.36l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M313.29 295.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M314 295.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M192.29 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M193 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M193.7 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M194.4 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M195.11 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M196.28 296.25l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M199.09 296.25l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M201.2 296.25l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M202.14 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M205.66 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M206.36 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M209.18 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M211.52 296.47l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M211.99 296.03l.703 2.678h.704l-1.407-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M214.34 296.47l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M215.51 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M216.21 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M220.43 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M223.95 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M225.36 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M228.17 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M228.87 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M229.58 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M230.28 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M230.99 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M231.69 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M232.39 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M233.1 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M235.21 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M235.91 296.03l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M236.61 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M238.72 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M239.43 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M240.13 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M245.06 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5252",
    d: "M245.76 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M246.46 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M247.17 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M260.53 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M261.24 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M261.94 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.64 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M263.35 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M264.05 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M264.75 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M268.97 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M269.68 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M273.19 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M276.01 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M276.71 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M278.82 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M280.93 296.03l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M281.64 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M282.34 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M283.04 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M283.75 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M284.45 296.03l.703.67-.703-.67m5.628 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.72 296.47l.235.446-.235-.446m1.173-.446l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.3 296.03l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.52 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.22 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.93 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.78 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M310.48 296.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M311.18 296.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M192.76 296.92l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M194.4 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M195.11 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M196.51 299.37l1.407-2.008c-1.82-.4-2.914.654-1.407 2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M199.09 296.92l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M200.03 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.25 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M204.96 296.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M205.66 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "M209.18 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M216.21 296.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M216.92 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M220.67 297.14l.235.446-.235-.446m2.58-.446l.703.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M228.17 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M229.58 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M230.28 296.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M230.99 296.69l.703 4.686 3.518 2.677 4.925.67.704-.67c-.52-1.812-6.268-9.642-7.036-5.355l-1.407-2.008h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.39 296.69v1.34l1.407-1.34h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M233.8 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M234.97 296.92l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M236.14 297.14l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M237.32 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M239.43 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M240.13 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M245.06 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M247.17 296.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M247.87 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M248.57 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M249.28 296.69l.703.67-.703-.67m9.145 0l.704.67-.705-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M259.12 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M259.83 296.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M260.53 296.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M261.24 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M268.97 296.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M269.68 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M272.49 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M273.19 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M275.31 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M276.01 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M276.71 296.69l-4.925 8.033c5.518-.063 7.887-2.874 8.442-8.033h-.703l-4.925 7.363 2.11-7.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M277.42 296.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M278.82 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M280.23 296.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M280.93 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M282.34 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M283.04 296.69l-4.924 8.702c3.275-1.536 5.708-5.148 4.924-8.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M283.75 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M284.45 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M290.08 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.3 296.69l.704.67-.704-.67m3.518 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.52 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.1 296.92l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M302.04 296.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.74 296.69v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.85 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.02 296.92l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M306.96 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M307.9 297.14l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M308.37 296.69l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M311.89 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M312.59 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M313.29 296.69l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M194.4 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M196.51 297.36l-.703 1.34h1.407l-.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M197.22 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M202.85 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M203.55 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M204.25 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M207.07 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M207.77 297.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "M208.47 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M209.18 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M209.88 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M210.58 297.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M211.29 297.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M212.69 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M214.1 297.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M216.92 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M223.25 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M227.47 297.36l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M228.17 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M230.28 297.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M231.69 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M236.61 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M238.02 297.36l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M240.13 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M243.18 297.81l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M245.29 297.81l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M248.57 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M249.28 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M249.98 297.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M257.72 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M258.42 297.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M259.12 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M269.68 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M272.49 297.36l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M273.19 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M275.31 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M276.01 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M277.89 297.59l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M278.82 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M280.23 297.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M280.93 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M281.64 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M282.34 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M283.75 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M290.08 297.36l.703.67-.703-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.3 297.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.71 298.03v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.11 297.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297.82 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M308.37 297.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M309.07 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M309.78 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M310.48 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M311.18 297.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M312.36 297.59l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M313.29 297.36l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M314 297.36l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M194.4 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M199.33 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M200.03 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M200.73 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M201.44 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M202.14 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M202.85 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M204.02 298.26l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M204.96 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M205.66 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M206.36 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M207.07 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M205.66 298.7v.67h6.33v.67h-6.33v.668h1.407v.67c-3.843.2-5.79 1.557-7.738 4.685l11.958-.67v.67c-3.244.98-7.965.63-9.146 4.017 4.49-1.744 10.988-2.342 13.366-6.694l-4.22 2.008 2.11-2.678-6.332-.67v-.67l11.256.67v.67h-2.11v.67l9.145-.67v-.67h-2.11v-.67h4.22v-.668l-5.627 1.34-16.18-3.348z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M213.4 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M214.1 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M216.92 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M217.62 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M220.43 298.03l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M223.01 298.26l.47.224-.47-.224m3.05-.223l.702.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M227.47 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M230.28 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M230.99 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232.86 298.26l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M238.02 298.03l2.11 1.34v-.67l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M238.96 298.48l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M240.83 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M249.98 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M250.68 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M251.39 298.03l.703.67-.703-.67m4.925 0l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M257.01 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M257.72 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M269.68 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M272.49 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M273.19 298.03l-4.22 6.694c2.666-1.298 5.056-3.697 4.22-6.694z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M273.9 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M274.6 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M275.31 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M276.71 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M277.42 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M278.12 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M280.23 298.03l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M280.93 298.03l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M281.64 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M283.04 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M283.75 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M288.67 298.03l.704.67-.704-.67zm5.63 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M296.41 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M309.07 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M309.78 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M310.48 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M311.18 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M311.89 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M312.59 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M313.29 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M314 298.03l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M314.7 298.03l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M194.64 299.15l.235.446-.235-.446m1.876-.446l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M197.22 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M198.39 298.93l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M199.33 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M200.03 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M202.85 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.55 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M204.25 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.96 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M214.1 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M214.8 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M216.92 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M217.62 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M218.32 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M220.43 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M221.84 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M222.54 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M224.65 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M225.36 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M226.06 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M230.28 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M230.99 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M233.8 298.7l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M240.83 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M242.94 298.7v2.678h.703l-.703-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M245.06 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M251.39 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M252.09 298.7l2.11 2.678-2.11-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M256.31 298.7l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M257.01 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M269.91 299.15l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.79 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M272.49 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M273.9 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M274.6 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M276.71 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M277.42 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M278.12 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M280.23 298.7l.704.67-.704-.67m2.814 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M288.67 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.71 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.78 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M310.48 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M311.18 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M313.29 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M314 298.7l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M314.7 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M315.4 298.7l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M193.7 299.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M195.11 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M195.81 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M196.51 299.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M203.55 299.37l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M204.25 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M204.96 299.37v.67h3.518l-3.518-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M208.47 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M209.18 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M209.88 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M210.58 299.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M211.29 299.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M214.8 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M215.51 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M216.21 299.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M216.92 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M218.32 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M219.03 299.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M219.73 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M220.43 299.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M221.14 299.37l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M221.84 299.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M222.54 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M223.25 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M223.95 299.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M224.65 299.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M225.36 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M230.99 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.21 299.37l2.11 2.008-2.11-2.008m4.22 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M241.77 299.82l.235.446-.235-.446m3.283-.446l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M267.57 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M271.08 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M271.79 299.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M273.9 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M274.6 299.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M276.71 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M277.42 299.37l.704.67-.704-.67m2.11 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M280.7 299.6l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M283.04 299.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M285.15 299.37l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.11 299.37l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.82 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.52 299.37v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M300.63 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.33 299.37v.67h3.518l-3.518-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M304.85 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M305.56 299.37l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.26 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.96 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M311.18 299.37l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M311.89 299.37l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M193.7 300.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M194.4 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M195.11 300.04l-1.407.67v.67l1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M204.96 300.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M211.99 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M212.69 300.04l.703.67-.703-.67m2.814 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "M216.21 300.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "M219.49 300.26l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M221.14 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M221.84 300.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M222.54 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M223.25 300.04v.67h2.814l-2.814-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M226.06 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M226.76 300.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M227.47 300.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M228.17 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M230.99 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M235.21 300.04l.703.67-.703-.67m4.22 0l.704 2.008h.704l-1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M245.06 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M254.2 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M267.57 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M271.08 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M273.19 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M273.9 300.04l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M276.01 300.04l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M276.71 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M279.53 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M280.23 300.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M282.34 300.04l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M283.04 300.04l.704.67-.704-.67m2.11 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.71 300.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.41 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.11 300.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.56 300.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.26 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M306.96 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M307.67 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M308.37 300.04l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M309.07 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M309.78 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M312.59 300.04l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M202.85 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M203.55 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M204.25 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M204.96 300.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M206.13 300.93l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M216.21 300.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M216.92 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M217.62 300.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M218.32 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M219.03 300.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M219.73 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M220.43 300.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M221.14 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M227.47 300.71l-2.11 2.008 2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M228.17 300.71v1.34h1.407l-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M228.87 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M229.58 300.71l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M230.99 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M235.91 300.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M239.43 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M241.54 300.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M245.06 300.71l.703.67-.703-.67m9.145 0l.704.67-.705-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M267.57 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M271.08 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M273.9 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M276.01 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M278.82 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.53 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M280.23 300.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M282.34 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M285.15 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M287.97 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M289.14 300.93l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.08 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.78 300.71l-.703 1.34.703-1.34m2.814 0l.703.67-.703-.67m13.366 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M307.67 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M308.37 300.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M309.07 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M309.78 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M310.48 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M311.18 300.71l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M311.89 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M312.59 300.71l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M313.29 300.71l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M201.44 301.38l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M202.14 301.38l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M202.85 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M207.54 301.6l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M208.71 301.83l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M218.79 301.6l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.43 301.38l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M221.14 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M223.25 301.38v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M229.58 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M230.99 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M231.69 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232.39 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M233.1 301.38l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a4208",
    d: "M233.8 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M236.61 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M237.32 301.38v1.34h1.407l-1.407-1.34zm7.03 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M245.06 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M266.86 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M267.57 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M269.68 301.38l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M272.49 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M273.19 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M275.31 301.38l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M276.01 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M279.29 301.6l.47.224-.47-.224m3.048-.223l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M284.45 301.38l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M285.15 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M290.78 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.49 301.38l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M292.19 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.89 301.38l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.82 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.52 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.22 301.38v1.34h1.407l-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.93 301.38l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M308.37 301.38l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M309.07 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M311.89 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M312.59 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M313.29 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M314.7 301.38l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M201.44 302.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M209.18 302.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M209.88 302.05v.67h2.814l-2.814-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M212.69 302.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M213.4 302.05v2.008l2.814-2.008H213.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M216.68 302.27l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M217.62 302.05l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M221.84 302.05l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M222.54 302.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M226.06 302.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M226.76 302.05l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M227.47 302.05l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M228.17 302.05v1.34h1.407l-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M230.05 302.27l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.69 302.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M232.39 302.05l.703.67-.703-.67zm1.41 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M234.5 302.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M240.6 302.27l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M244.35 302.05l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M266.86 302.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M269.68 302.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M271.79 302.05l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M272.49 302.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M275.54 302.5l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M278.12 302.05l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M278.82 302.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M282.11 302.27l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M284.45 302.05l.703.67-.703-.67m8.676.446l.235.446-.234-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.83 302.5l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.3 302.05l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M296.41 302.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.11 302.05l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.63 302.05v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M302.74 302.05l1.407 1.34v-1.34h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.15 302.05l.703.67-.703-.67m4.925 0l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M309.78 302.05l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M313.29 302.05l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M314.47 302.27l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M200.73 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M213.4 302.72l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M223.25 302.72l2.814 1.34v-.67l-2.814-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M223.95 302.72l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M224.65 302.72l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M225.36 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M226.06 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M227.47 302.72l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M229.58 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M231.69 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "M234.5 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M241.07 303.17l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M243.65 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M244.35 302.72l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M266.86 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M269.21 303.17l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M269.68 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M271.79 302.72l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M274.6 302.72l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M278.35 303.17l.235.446-.235-.446m3.283-.446l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M284.45 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M286.56 302.72l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M287.26 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M285.86 303.39v.67l6.332-.67h-6.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.19 302.72l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.3 302.72l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.11 302.72l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.82 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.52 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.15 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M304.85 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M305.56 302.72l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M306.26 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.96 302.72l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M200.03 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M209.18 303.39l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M209.88 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M212.69 303.39l-.703 2.008.703-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M215.51 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M216.21 303.39l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M216.92 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M217.62 303.39l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M218.32 303.39v.67h2.814l-2.814-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M221.14 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M221.84 303.39l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M222.54 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M219.73 306.74l14.773-2.008c-4.594-1.838-11.355-1.68-14.773 2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.17 303.39v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M230.28 303.39v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M232.39 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M233.1 303.39l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M233.8 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M234.5 303.39l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M243.65 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M266.16 303.39l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M270.38 304.73l2.11-1.34-2.11 1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M274.6 303.39l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M277.42 303.39l-1.407 2.008h2.11l-.703-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M281.4 303.61l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M283.75 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M284.92 303.61l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.08 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.19 303.39l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M292.89 303.39v.67l9.85 2.677v-.67l-9.85-2.677z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.52 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.22 303.39l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.93 303.39l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.15 303.39l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M304.85 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M305.56 303.39l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M306.26 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M306.96 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M307.67 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M308.37 303.39l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.07 303.39l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M199.33 304.06l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M200.03 304.06l.703.67-.703-.67m2.814 0v1.34h2.11v-1.34h-2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M204.96 304.06l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M205.66 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M206.36 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M207.54 304.28l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M215.51 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M217.62 304.06l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M218.32 304.06v.67h2.814l-2.814-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M221.14 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M221.84 304.06l.704.67-.704-.67m12.663 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M235.91 304.06v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M238.02 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M240.13 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M240.83 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M243.65 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd8c8c",
    d: "M244.82 304.28l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "M245.76 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c4a42",
    d: "M253.5 304.06l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad524a",
    d: "M254.2 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "M261.94 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd8c8c",
    d: "M263.11 304.28l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M266.16 304.06l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M268.27 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M277.42 304.06l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M280.23 304.06l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M280.93 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M283.04 304.06l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M283.75 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M283.75 306.07l17.587 2.678v2.677c1.992-5.878-14.25-9.76-17.587-5.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M292.19 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.89 304.06l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M293.6 304.06l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.3 304.06l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.93 304.06l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M300.63 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.33 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M302.04 304.06l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M305.56 304.06l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M309.07 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M309.78 304.06l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M310.95 304.28l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M311.89 304.06l.703.67-.703-.67m-113.26.67l-1.407 2.008 1.407-2.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M199.33 304.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M200.73 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M201.91 304.95l.47.224-.47-.224m9.38-.223l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M214.8 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M219.73 304.73l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M220.43 304.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.86 304.95l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M233.8 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "M234.5 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M235.68 304.95l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M236.61 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M237.32 304.73v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M239.43 304.73v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M241.54 304.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M225.36 316.78v-.67l-4.22.67v-.67c19.037-5.743 47.093-5.743 66.128 0v.67l-3.517-.67c3.472 5.038 12.97 1.915 9.817-3.945-2.688-4.997-12.483-5.588-17.555-6.277-14.296-1.94-30.052-2.1-44.32.128-5.08.793-11.26 1.215-15.316 4.598-2.888 2.41-1.836 7.29 2.015 8.37 2.38.667 5.028-1.13 6.97-2.204z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M266.16 304.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M268.97 304.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M270.15 304.95l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "M271.08 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M273.9 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M274.6 304.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M275.31 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M276.71 304.73l.703.67-.703-.67m3.518 0l-.704 1.34.703-1.34m2.814 0l.705.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.6 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295.47 304.95l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.41 304.73l-.704 1.34.704-1.34m4.22 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M301.33 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M302.04 304.73l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M302.74 304.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M303.45 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.15 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M306.26 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M306.96 304.73l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M310.48 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M311.18 304.73l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M311.89 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M312.59 304.73l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M198.62 305.4l4.22 2.008-4.22-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M210.11 305.84l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M210.58 305.4l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M214.1 305.4l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M214.8 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M219.73 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.17 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M228.87 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.58 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M230.28 305.4l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M230.99 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M231.69 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M232.39 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M233.1 305.4l.704.67-.704-.67m41.506 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M275.31 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M276.01 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M276.71 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M277.42 305.4l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a4208",
    d: "M278.12 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M278.82 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M280.23 305.4l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M282.34 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M283.04 305.4l.704.67-.704-.67m1.407 0l3.518.67-3.518-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M287.26 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.41 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M297.11 305.4l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.82 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.52 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M302.04 305.4l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M304.15 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M304.85 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M305.56 305.4l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.26 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M306.96 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M311.89 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M312.59 305.4l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M197.92 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M202.85 306.07v1.34h1.407v-1.34h-1.407m5.16.446l.233.446-.234-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M208.94 306.29l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M212.69 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M213.4 306.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M214.1 306.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M219.03 306.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M222.31 306.29l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M223.72 306.29l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M224.65 306.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M225.36 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M226.06 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M226.76 306.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M227.47 306.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M228.17 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M228.87 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M244.35 306.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M245.06 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M245.76 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M248.57 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M249.28 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M254.67 306.29l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M255.61 306.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M259.59 306.29l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M260.53 306.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M279.53 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M280.23 306.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M280.93 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M281.64 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M282.34 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M283.04 306.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M283.75 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M287.97 306.07v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.08 306.07l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.78 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.82 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M298.52 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M299.22 306.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M299.93 306.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M300.63 306.07l.703.67-.703-.67m2.11 0l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M303.45 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M305.56 306.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M306.26 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M306.96 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M307.67 306.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M197.22 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M204.25 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M204.96 306.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M205.66 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M206.83 306.96l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M211.29 306.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M211.99 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M212.69 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M218.32 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M219.49 306.96l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M218.32 308.07v.67l4.22-1.34-4.22.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M222.54 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M223.25 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M223.95 306.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M224.65 306.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M233.8 306.74l.703.67-.703-.67zm2.81 0l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M243.65 306.74l.703.67-.703-.67zm2.81 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M249.28 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M257.01 306.74l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M258.42 306.74l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M261.24 306.74l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M261.94 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M264.75 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M266.16 306.74l-.703 4.686.703-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M266.86 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M268.27 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M268.97 306.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M269.68 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M271.08 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M273.9 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M283.04 306.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M283.75 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "M284.45 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M285.15 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M286.56 306.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M287.26 306.74v.67l7.035 1.338-7.035-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.08 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.49 306.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M292.19 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M293.13 307.18l.235.446-.235-.446m6.097-.446l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M299.93 306.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M300.63 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M301.33 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.04 306.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.74 306.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M304.15 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M306.96 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M307.67 306.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M308.37 306.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M201.44 307.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M202.14 307.41l.704.67-.704-.67m6.332 0l.703.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M209.18 307.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M209.88 307.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M210.58 307.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M211.29 307.41l.704.67-.704-.67m6.33 0l.705.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M218.32 307.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M221.14 307.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M221.84 307.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M230.28 307.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M236.61 307.41l.703.67-.703-.67m2.11 0l.704.67-.703-.67m5.394.223l.47.223-.47-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M245.06 307.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M246.23 307.63l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M257.01 307.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M261 307.63l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M264.05 307.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M268.5 307.85l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M275.31 307.41l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M277.42 307.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M280.23 307.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M285.86 307.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M286.56 307.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M287.26 307.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M287.97 307.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.6 307.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M294.3 307.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295 307.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.71 307.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.41 307.41l.703.67-.703-.67m3.518 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.63 307.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M301.33 307.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M302.04 307.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M302.74 307.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M303.91 307.63l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M304.85 307.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M201.44 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M205.66 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M206.36 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M207.07 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M207.77 308.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M208.47 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M209.18 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M216.92 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M217.62 308.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "M219.03 308.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M219.73 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M224.42 308.3l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M229.58 308.07l.703.67-.703-.67zm3.75.45l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M235.21 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M235.91 308.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M237.32 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M245.76 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M246.46 308.07l.703.67-.703-.67m1.407 0l.703.67-.703-.67zm2.113 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M255.61 308.07v2.008h.704l-.704-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M256.31 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M259.12 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M259.83 308.07l.704 2.008-.704-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M264.05 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M264.75 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M274.6 308.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M275.31 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M276.71 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M278.12 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M279.53 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M280.23 308.07l-.703 2.008.703-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M281.17 308.52l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M283.04 308.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M283.75 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M287.97 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M288.67 308.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M289.38 308.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.08 308.07l.703.67-.703-.67m4.455.446l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M295.71 308.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M296.41 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M297.11 308.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M297.82 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.52 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.33 308.07l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M302.04 308.07l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M303.45 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M304.15 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M304.85 308.07l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M201.44 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M204.25 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M204.96 308.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M205.66 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M216.92 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M217.62 308.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M218.32 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M221.84 308.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M222.54 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M223.25 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M223.95 308.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M224.65 308.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M230.99 308.74l.703.67-.703-.67zm6.33 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M249.04 308.97l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M256.31 308.74l.703.67-.703-.67m7.738 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M268.27 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M269.68 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M276.01 308.74v2.678l2.814-.67-2.814-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M278.12 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M279.53 308.74l.703.67-.703-.67m3.987.223l.468.223-.468-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M285.15 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M285.86 308.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M289.38 308.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M290.08 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.25 308.97l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.19 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M293.36 308.97l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M295 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.71 308.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.41 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M297.11 308.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M297.82 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M298.52 308.74l1.407 2.008-1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M299.22 308.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M299.93 308.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.63 308.74l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M302.74 308.74l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M202.85 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M203.55 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M204.25 309.41l.703.67-.703-.67m11.256 0l.703.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "M216.21 309.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M216.92 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M219.49 309.64l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M221.84 309.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M223.25 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M227.47 309.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M228.17 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M231.22 309.86l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M246.46 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M247.17 309.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M248.1 309.86l.235.446-.235-.446m2.11 0l.235.446-.234-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M256.78 309.64l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M259.12 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M263.35 309.41l.704.67-.704-.67zm8.44 0l-.703 2.678.703-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M273.9 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M274.84 309.86l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M275.54 309.86l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M278.82 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M280.23 309.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M281.17 309.86l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M282.34 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M285.15 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M285.86 309.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M290.78 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M291.49 309.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M292.19 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M292.89 309.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M293.6 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M294.3 309.41l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M295 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M295.71 309.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M296.41 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.11 309.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M297.82 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M299.93 309.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M300.63 309.41l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M302.04 309.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M302.74 309.41l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M202.14 310.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M202.85 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M214.8 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M215.51 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M216.21 310.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M217.62 310.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M218.32 310.08l.703.67-.703-.67zm2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M221.84 310.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M223.25 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M226.06 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M229.58 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M235.21 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M235.91 310.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M244.12 310.31l.47.224-.47-.224m2.11 0l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M247.17 310.08l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M249.04 310.31l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M250.68 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M255.61 310.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M257.01 310.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M257.72 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M261 310.31l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M263.35 310.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M264.75 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M270.38 310.08l.703.67-.703-.67zm9.15 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M280.23 310.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M282.34 310.08l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M285.15 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M285.86 310.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M287.97 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M288.91 310.53l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M292.19 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.89 310.08l1.407 1.34v-1.34h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M294.3 310.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M297.11 310.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M297.82 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M298.52 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M300.63 310.08l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.04 310.08l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M202.14 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M214.1 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M214.8 310.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M216.92 310.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M217.62 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M219.03 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M219.73 310.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M221.84 310.75l.704.67-.704-.67m4.22 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M227.47 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M228.17 310.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M230.28 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M230.99 310.75l-.704 1.34.704-1.34zm9.84 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M243.65 310.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M247.17 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M247.87 310.75l.703.67-.703-.67m2.11 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M250.68 310.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M256.31 310.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M258.42 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M263.35 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M264.75 310.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M274.6 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M275.31 310.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M276.71 310.75l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M278.12 310.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M278.82 310.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M283.04 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M284.45 310.75l-.703 1.34.703-1.34zm1.41 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M287.26 310.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M292.89 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M294.3 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295.24 311.2l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M295.71 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M296.41 310.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M300.63 310.75l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M302.04 310.75l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M213.4 311.42l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M214.1 311.42l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M219.03 311.42l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M219.73 311.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M221.14 311.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M222.07 311.87l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M223.48 311.87l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M223.95 311.42l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M226.06 311.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M227.47 311.42l.704.67-.704-.67zm5.63 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M238.02 311.42l.703.67-.703-.67zm6.33 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M245.06 311.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M245.76 311.42l.703.67-.703-.67m1.876.223l.47.223-.47-.223m2.814 0l.47.223-.47-.223zm8.67-.223l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M259.83 311.42l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M260.53 311.42l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M262.64 311.42l.703.67-.703-.67m1.407 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M264.75 311.42v.67h2.11l-2.11-.67m3.518 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M268.97 311.42l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M274.6 311.42l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M279.53 311.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M281.17 311.87l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M282.34 311.42l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M285.86 311.42l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M293.6 311.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.3 311.42l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.71 311.42l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.41 311.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M297.11 311.42l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M300.87 311.87l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.33 311.42l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M302.04 311.42l.704.67-.704-.67m-88.64.67l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M214.1 312.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M217.62 312.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M218.32 312.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M221.14 312.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M222.54 312.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M223.95 312.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M225.36 312.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M226.76 312.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M227.47 312.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M230.99 312.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M231.69 312.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M232.39 312.09l.703.67-.703-.67m42.913 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M276.01 312.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M276.71 312.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M277.42 312.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M278.82 312.09l.703.67-.703-.67m1.407 0l.704.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M281.64 312.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M282.57 312.54l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M283.51 312.31l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M285.86 312.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M286.56 312.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M287.97 312.09l.703.67-.703-.67zm1.64.45l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M294.3 312.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M295 312.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M295.71 312.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M296.41 312.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M297.11 312.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M297.82 312.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.33 312.09l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M302.04 312.09l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "M213.4 312.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M219.73 312.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M220.43 312.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M222.54 312.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M225.36 312.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M226.76 312.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M227.47 312.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M242.94 312.76v.67h4.22l-4.22-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M247.17 312.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M247.87 312.76v.67h13.366l-13.366-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M261.24 312.76v.67h4.22l-4.22-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M265.46 312.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M280.23 312.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M280.93 312.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M281.64 312.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M283.51 312.98l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M285.15 312.76l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M285.86 312.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M287.97 312.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M294.3 312.76l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M297.35 313.21l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M297.82 312.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M298.52 312.76l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M301.33 312.76l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M204.96 313.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M205.66 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "M206.36 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M209.18 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M209.88 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M210.58 313.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "M213.4 313.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M218.32 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M219.26 313.88l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M221.14 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M223.95 313.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M224.65 313.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M234.27 313.65l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M235.21 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M235.91 313.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "M236.61 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M237.79 313.65l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "M238.72 313.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M239.43 313.43v.67h2.814l-2.814-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M242.24 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M242.94 313.43v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M245.06 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M245.76 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M246.46 313.43l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M247.17 313.43c1.85 2.222 3.342 3.202 6.332 2.678l-6.332-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M251.39 313.43l1.407 3.347h1.408l-2.814-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M252.09 313.43l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M254.9 313.43l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M255.61 313.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M256.31 316.78l5.628-2.678c-2.867-1.142-6.19-.818-5.628 2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M261.94 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.64 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "M268.97 313.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M270.15 313.65l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c3939",
    d: "M271.08 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M271.79 313.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M272.49 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M273.66 313.65l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M274.6 313.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M284.92 313.65l.47.224-.47-.224m1.64-.223l.705.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M287.26 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M287.97 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M289.38 313.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M294.3 313.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M297.82 313.43l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M298.52 313.43l.703.67-.703-.67zm3.52 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M302.74 313.43l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M204.25 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M204.96 314.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M205.66 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M204.96 320.12c7.344-4.21 16.793 7.4 22.512-2.008l-.704-.67c-2.337.82-5.164 2.753-7.735 2.393-1.72-.24-19.48-11.747-14.073.285z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M209.88 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M210.58 314.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M211.29 314.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M211.99 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M212.69 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M213.4 314.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M218.32 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M219.73 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M228.17 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M228.87 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M229.58 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "M230.28 314.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M230.99 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "M231.69 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M232.86 314.32l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M234.27 314.32l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M235.21 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M246.46 314.1l2.11 2.008-2.11-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M254.9 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M261.24 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M261.94 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M273.66 314.32l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M275.07 314.32l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "M276.01 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M276.71 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M277.42 314.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M278.12 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M278.82 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M279.53 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M285.86 314.1l.704.67-.704-.67m2.345.446l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "M294.3 314.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M295 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M295.71 314.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "M296.41 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M297.11 314.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M297.82 314.1l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M282.34 317.45c-.974 9.363 16.566.076 21.105 2.678 2.42-5.114-3.23-7.393-7.61-4.728-2.097 1.277-3.144 3.904-5.784 4.367-2.602.456-5.402-1.404-7.71-2.317z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M302.04 314.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M302.74 314.1l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M303.45 314.1l.703.67-.703-.67m-99.896.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M204.25 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M212.69 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M213.4 314.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M214.1 314.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M219.03 314.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M219.73 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M223.95 314.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M224.65 314.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M225.36 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "M226.06 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M226.76 314.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M227.47 314.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M228.17 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M228.87 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M254.2 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M254.9 314.77l1.407 2.008-1.407-2.008m4.925 0l-.704 1.34.705-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M260.53 314.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M261.24 314.77l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M278.82 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M279.53 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M280.23 314.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M280.93 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "M281.64 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M282.34 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M283.04 314.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M283.75 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M288.67 314.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M294.3 314.77l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M295 314.77l.703.67-.703-.67m8.442 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M304.15 314.77l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M202.85 315.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M203.55 315.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M213.4 315.44l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M214.1 315.44l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M221.84 315.44l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M224.65 315.44l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M225.36 315.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M248.57 315.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M254.2 315.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M259.83 315.44l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M282.34 315.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "M283.04 315.44l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M283.75 315.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M284.45 315.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M285.15 315.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M285.86 315.44l1.407 1.34-1.407-1.34m7.738 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M294.3 315.44l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M304.15 315.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M304.85 315.44l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M202.85 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M203.55 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M214.1 316.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M214.8 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M221.61 316.33l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M225.36 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M226.06 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M245.76 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M246.46 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M247.17 316.11v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M249.28 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M249.98 316.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M254.2 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M254.9 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M257.72 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M258.42 316.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M259.12 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M259.83 316.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M260.53 316.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M261.24 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M261.94 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M281.64 316.11l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M282.34 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M283.04 316.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M285.86 316.11l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M292.89 316.11l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M293.6 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M304.85 316.11l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "M202.85 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M214.8 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M215.51 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M224.65 316.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M225.36 316.78l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M226.06 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M226.76 316.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M242.94 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M243.65 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M244.35 316.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M245.06 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M245.76 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M246.46 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M245.76 320.12l5.628.67c-.344-4.107-4.818-5.11-5.628-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M249.98 316.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M250.68 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M251.39 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M252.09 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M252.79 316.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M253.5 316.78v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M255.61 316.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M256.31 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M257.01 316.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M257.72 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M257.01 317.45l.704 3.347 4.924-.67c-.576-3.284-2.52-3.348-5.628-2.677z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M261.94 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423131",
    d: "M262.64 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M263.35 316.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M264.05 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M264.75 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M265.46 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M281.64 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M282.34 316.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M283.04 316.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M292.89 316.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M305.09 317.22l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M202.85 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M214.8 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M215.51 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M223.25 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M223.95 317.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M225.36 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M226.76 317.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M227.47 317.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M240.13 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M240.83 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M241.54 317.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M242.24 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M242.94 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M243.65 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M244.35 317.45l-2.814.67v4.016c2.433-.982 3.837-2.122 2.814-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M245.06 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M251.39 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M252.09 317.45v4.016h4.22v-4.016h-4.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M256.31 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M262.64 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M263.35 317.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M264.05 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M264.75 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M265.46 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "M266.16 317.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M266.86 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M267.57 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M280.23 317.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M280.93 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M281.64 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M283.04 317.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M283.75 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M284.45 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M292.19 317.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M292.89 317.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M203.08 318.56l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M203.55 318.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M207.07 318.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M207.77 318.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M215.51 318.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M216.21 318.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M221.84 318.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M222.54 318.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M223.25 318.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M227.47 318.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M240.37 318.56l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M240.83 318.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M245.06 318.12v2.678h.703l-.703-2.678m6.33 0v2.678h.705l-.704-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M256.31 318.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M257.01 318.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M262.64 318.12l-2.11 3.347h2.11v-1.34l1.407.67v-2.677h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M264.05 318.12v3.347l2.814.67.703-3.348-3.517-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M266.86 318.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "M267.57 318.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M280.23 318.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M280.93 318.12l.703.67-.703-.67m3.518 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M285.15 318.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M285.86 318.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M291.49 318.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M292.19 318.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M300.4 318.34l.47.224-.47-.224m3.752-.223l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M304.85 318.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M197.92 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M198.62 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M202.14 318.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M203.55 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M205.66 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M206.36 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M207.07 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M207.77 318.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M208.47 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M209.18 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M209.88 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M210.58 318.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M216.21 318.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M217.15 319.23l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M220.43 318.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M221.14 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M221.84 318.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M222.54 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M226.76 318.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M227.47 318.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M240.83 318.78l.703.67-.703-.67m15.477 0v1.34h1.407v-1.34h-1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M267.8 319.23l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M280.23 318.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M280.93 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M285.86 318.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M286.56 318.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M287.26 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M290.78 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M291.49 318.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M292.19 318.78l.703.67-.703-.67m4.925 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M297.82 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M298.99 319.01l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M299.93 318.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M300.63 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M301.33 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M302.04 318.78l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M304.15 318.78l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M305.32 319.01l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M309.54 319.01l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M195.81 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M196.51 319.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "M197.22 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M197.92 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M194.4 321.46c2.827 5.764 17.61 7.367 21.105 1.34-8.182.983-13.45-5.158-21.105-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M202.14 319.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M202.85 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M203.55 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M206.36 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M214.8 322.13c-6.6-5.067-10.878 1.308 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M209.88 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M210.58 319.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M211.29 319.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M211.99 319.45l.703.67-.703-.67zm8.44 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M221.14 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "M226.76 319.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M240.83 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M280.93 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M281.64 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M287.26 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M287.97 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M295.71 319.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M296.88 319.68l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M297.82 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M293.6 321.46v.67c3.633.437 7.668 1.733 8.442-2.678l-8.442 2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M302.04 319.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M303.45 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M304.15 319.45l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M304.85 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M305.56 319.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M292.89 322.8c3.475 5.997 18.307 4.366 21.105-1.34-7.655-3.817-12.922 2.324-21.105 1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M309.78 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "M310.48 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M311.18 319.45l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M311.89 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M312.59 319.45l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M194.4 320.12l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "M195.11 320.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M195.81 320.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M204.25 320.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M211.99 320.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M213.16 320.35l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M214.1 320.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M226.06 320.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M226.76 320.12l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M240.83 320.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M245.76 320.12v.67l2.814.67-2.814-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M256.31 320.12l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M257.01 320.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M259.83 320.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M262.64 320.12l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M266.86 320.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M267.57 320.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M280.93 320.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "M281.64 320.12l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M293.6 320.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M294.3 320.12l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M295 320.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M295.71 320.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M302.04 320.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M302.74 320.12l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M311.89 320.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "M312.59 320.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M313.29 320.12l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M194.4 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M204.25 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M204.96 320.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M205.66 320.79l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M213.4 320.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M214.1 320.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M214.8 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M215.51 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M224.65 320.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M225.36 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M240.83 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M244.35 320.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M245.06 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M245.99 321.24l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M246.93 321.02l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M248.57 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M249.28 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M249.98 320.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M250.68 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M251.39 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M256.31 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M257.72 320.79v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M259.83 320.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M261.24 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M262.64 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M266.86 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M267.57 320.79l.703.67-.703-.67m14.07 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M283.04 320.79l.704.67-.704-.67m9.145 0l.704.67-.705-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M292.89 320.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M294.3 320.79l.704.67-.704-.67m7.738 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M302.74 320.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M303.45 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M313.29 320.79l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M314 320.79l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M193.7 321.46l3.518 4.016-3.518-4.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M205.66 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M214.8 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M215.51 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "M216.21 321.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M216.92 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M217.62 321.46l.704.67-.704-.67m5.628 0l.703.67-.702-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M223.95 321.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M224.65 321.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M225.36 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "M240.83 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M242.24 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M242.94 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5252",
    d: "M243.65 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M244.35 321.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M245.06 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M246.46 321.46v.67h2.814l-2.814-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M249.28 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M249.98 321.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M250.68 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M251.39 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M252.09 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M252.79 321.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M253.97 321.69l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M254.9 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M255.61 321.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M256.31 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "M257.01 321.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M257.72 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M258.42 321.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M259.12 321.46v.67h2.814l-2.814-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M261.94 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M262.64 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M263.35 321.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M264.05 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2131",
    d: "M264.75 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M265.46 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M266.86 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M283.04 321.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M283.75 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M284.45 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M290.08 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M290.78 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M291.49 321.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M292.19 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M292.89 321.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M314 321.46l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M314.7 321.46l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M193 322.13l2.814 2.678L193 322.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M205.66 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M206.36 322.13l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M211.99 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M212.93 322.58l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M213.87 322.35l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M214.8 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "M215.51 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M216.92 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M217.62 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M218.32 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2131",
    d: "M219.03 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M219.73 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c4239",
    d: "M220.43 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad524a",
    d: "M221.14 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M221.84 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M222.54 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M223.25 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M223.95 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M240.83 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2131",
    d: "M241.54 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M242.24 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M242.94 322.13l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M245.76 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M246.46 322.13v.67h2.814l-2.814-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M249.28 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M249.98 322.13l-.703 2.678.703-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M251.15 322.35l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M252.09 322.13l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M252.79 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M253.97 322.35l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M254.9 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M255.61 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M256.31 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M257.01 322.13c2.57 3 6.954 6.73 10.552 3.347l-10.552-3.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M258.42 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M259.12 322.13v.67h2.814l-2.814-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M261.94 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.64 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M265.46 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "M266.16 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M266.86 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M284.45 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M285.15 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M285.86 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad524a",
    d: "M287.03 322.35l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M287.97 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "M288.67 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M289.38 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M290.08 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M290.78 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M292.19 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M292.89 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M294.07 322.35l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M295.24 322.58l.235.446-.235-.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M295.71 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M301.33 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M314 322.13l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M314.7 322.13l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M315.4 322.13l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M192.29 322.8l2.814 2.678-2.814-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M193 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M206.36 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M208.24 323.02l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M209.18 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M209.88 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M210.58 322.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M211.76 323.02l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M215.51 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M216.21 322.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M240.83 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M244.35 322.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M245.06 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M245.76 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M241.54 325.48c3.306 3.105 6.798.214 9.145-2.678l-9.145 2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M252.09 322.8l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M256.31 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M257.01 322.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M262.64 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M263.35 322.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M264.05 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M266.86 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M292.19 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M295.71 322.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M296.41 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M297.11 322.8l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M297.82 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M298.52 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M299.22 322.8v.67h2.11l-2.11-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M301.33 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M313.29 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M314.7 322.8l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M315.4 322.8l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M191.59 323.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M193.7 323.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M215.51 323.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M216.21 323.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M243.65 323.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M244.35 323.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M250.68 323.47l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M257.01 323.47l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M257.72 323.47l.703.67-.703-.67m6.332 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M264.75 323.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M292.19 323.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M312.59 323.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M313.29 323.47l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M314.7 323.47l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M315.4 323.47l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M192.29 324.14l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M214.8 324.14l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M215.51 324.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M242.24 324.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M242.94 324.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M243.65 324.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M250.68 324.14l.703.67-.703-.67m7.035 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M258.42 324.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M259.12 324.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M264.75 324.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M265.46 324.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M266.16 324.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M292.19 324.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M292.89 324.14l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M311.89 324.14l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M312.59 324.14l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M316.11 324.14l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M191.59 324.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M193 324.81l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M193.7 324.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M195.11 324.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M195.81 324.81l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "M214.8 324.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M240.83 324.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M241.54 324.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M242.24 324.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M248.57 324.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M249.28 324.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M259.12 324.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M259.83 324.81l.704.67-.704-.67m6.33 0l.705.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M266.86 324.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M267.57 324.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M292.89 324.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M293.6 324.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M312.59 324.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a59494",
    d: "M314 324.81l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M315.4 324.81l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M316.11 324.81l-.703 2.008.703-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M192.29 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M194.4 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M195.11 325.48l4.925 4.016-4.925-4.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M195.81 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M197.22 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M203.55 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M204.25 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c3939",
    d: "M204.96 325.48l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#843129",
    d: "M209.88 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5252",
    d: "M213.4 325.48l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M214.1 325.48l.704.67-.704-.67m26.03 0l.702.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M240.83 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M247.17 325.48l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M247.87 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M248.57 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M259.83 325.48l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M260.53 325.48l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M267.57 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M268.27 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M293.6 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M294.3 325.48l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M295 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M297.82 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c4a4a",
    d: "M298.52 325.48l.703.67-.703-.67zm4.22 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M303.45 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M304.15 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M304.85 325.48l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M311.89 325.48l-2.11 2.678 2.11-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M312.59 325.48l-3.518 4.686 3.518-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M313.76 325.7l.47.224-.47-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M192.29 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M193 326.15l1.407 2.008L193 326.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M194.4 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M196.51 326.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M197.22 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M197.92 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M201.44 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M202.14 326.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M202.85 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M203.55 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M240.13 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M240.83 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M241.54 326.15l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M246.46 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M247.17 326.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M247.87 326.15l.703.67-.703-.67m12.663 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M261.24 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M261.94 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M266.86 326.15l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M267.57 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M268.27 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M304.15 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M304.85 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M305.56 326.15l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M306.26 326.15l.703.67-.703-.67m3.518 0l-.704 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M310.48 326.15l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M313.29 326.15l.703.67-.703-.67m1.407 0l-2.11 2.678 2.11-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M193.7 326.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M195.11 326.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M197.92 326.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M198.62 326.82l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M201.44 326.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M202.14 326.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M241.54 326.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M245.06 326.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M245.76 326.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M246.46 326.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M261.94 326.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M262.64 326.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M263.35 326.82l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M266.86 326.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M306.26 326.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M306.96 326.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M309.78 326.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M312.59 326.82l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M314.7 326.82l-1.407 2.008 1.407-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M195.81 327.49l2.814 2.678-2.814-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M196.51 327.49l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M198.62 327.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M199.33 327.49l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M200.03 327.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M200.73 327.49l.703.67-.703-.67m41.506 0l.703.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M242.94 327.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M243.65 327.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M244.35 327.49l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M245.06 327.49l.703.67-.703-.67m18.29 0l.705.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M264.05 327.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M264.75 327.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M265.46 327.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M266.16 327.49l.704.67-.704-.67m40.803 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M307.67 327.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M308.37 327.49l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "M309.07 327.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M311.89 327.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M197.22 328.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M199.33 328.16l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M200.03 328.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M242.94 328.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M243.65 328.16l.703.67-.703-.67m21.105 0l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M265.46 328.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M307.67 328.16l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M308.37 328.16l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M309.07 328.16l.703.67-.703-.67m2.11 0l.704.67-.704-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M195.11 328.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M195.81 328.83l2.814 2.678-2.814-2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M197.92 328.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M310.48 328.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M311.89 328.83l-.704 1.34.704-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M312.59 328.83l-.703 1.34.703-1.34m-116.78.67l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M198.62 329.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M309.78 329.49l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M196.51 330.16l1.407 1.34-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M198.62 330.16l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M310.48 330.16l.703.67-.703-.67m-113.97.67l1.407 1.338-1.407-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M309.78 330.83l.703.67-.703-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M311.18 330.83l-.703 1.34.703-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M230.89 207.51l1.132-.302a.824.824 0 0 0 .362.452c.164.092.38.122.65.09.298-.034.515-.112.652-.233a.344.344 0 0 0 .114-.31.285.285 0 0 0-.11-.196c-.063-.045-.197-.078-.402-.1-.952-.086-1.563-.195-1.832-.327-.372-.184-.584-.474-.635-.87-.045-.36.065-.677.33-.956.267-.28.713-.454 1.337-.527.595-.07 1.05-.028 1.36.123.314.15.548.4.704.748l-1.06.318a.64.64 0 0 0-.313-.34c-.14-.07-.328-.092-.568-.064-.304.036-.516.1-.636.197-.08.068-.115.147-.103.238.01.078.058.14.14.185.114.06.485.122 1.113.183.63.06 1.08.174 1.347.337.265.167.42.424.464.772.05.38-.076.724-.373 1.036-.297.312-.772.505-1.424.58-.592.07-1.076.01-1.452-.178a1.63 1.63 0 0 1-.794-.852zm-5.1-.368a2.14 2.14 0 0 1 .146-1.087c.145-.362.377-.653.698-.872.323-.22.698-.353 1.123-.403.658-.076 1.223.065 1.695.424.472.356.748.844.828 1.464.08.626-.066 1.17-.44 1.632-.37.46-.876.726-1.52.8-.398.047-.79.005-1.174-.124a1.869 1.869 0 0 1-.92-.656c-.23-.31-.376-.703-.437-1.178zm1.185-.078c.053.41.195.712.428.907.232.195.5.275.8.24a.976.976 0 0 0 .71-.415c.176-.242.238-.57.185-.985-.052-.405-.195-.705-.427-.9a1.006 1.006 0 0 0-.794-.24.996.996 0 0 0-.715.416c-.176.242-.238.568-.185.978zm-3.578-2.25l-.13-1.014 1.15-.133.13 1.012-1.15.133zm.603 4.694l-.53-4.135 1.15-.133.53 4.134-1.15.134zm-6.78-5.005l2.213-.257c.5-.058.885-.066 1.156-.024.364.058.687.198.97.42.284.223.514.51.692.86.178.35.3.79.37 1.325.06.47.05.882-.028 1.236a2.482 2.482 0 0 1-.513 1.083c-.185.22-.45.404-.792.555-.257.112-.61.194-1.057.246l-2.278.265-.732-5.707zm1.335.825l.485 3.78.904-.105c.338-.04.58-.086.726-.14.19-.07.342-.167.456-.294.117-.127.2-.323.25-.587.047-.266.044-.62-.013-1.06-.056-.442-.14-.776-.253-1.003a1.323 1.323 0 0 0-.414-.513 1.21 1.21 0 0 0-.595-.204c-.173-.016-.507.004-1 .06l-.545.065z",
    fill: "#ecca5e"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ecca5e",
    d: "M233.383 223.395l17.104 21.387-.83.96-17.103-21.387zm44.017-1.627l-19.112 25.276-1.465-.506 19.113-25.276zm-48.427 5.858l20.24 18.744-.67 1.065-20.24-18.744zm-4.687 4.334l22.225 16.585-.547 1.128-22.225-16.585zm55.989-3.244l-20.037 18.942-1.108-.656 20.036-18.943zm4.435 3.51l-22.435 16.328-1.01-.787L283.7 231.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.26 229.62l4.638-5.894-.563-.4-4.075 6.294z",
    fillOpacity: 0.564,
    fill: "#7b5a00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.75 243.52l4.638-5.894-.563-.4-4.075 6.294z",
    fillOpacity: 0.475,
    fill: "#7b5a00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 236.85l4.638-5.894-.563-.4L266 236.85z",
    fillOpacity: 0.68,
    fill: "#7b5a00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.83 237.56l6.493-4.007-.383-.56-6.11 4.567z",
    fillOpacity: 0.525,
    fill: "#7b5a00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33 239.95l5.77-4.907-.47-.5-5.3 5.407z",
    fillOpacity: 0.398,
    fill: "#7b5a00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M213.63 288.63h-.703c-.13-3.835-1.626-6.29-5.628-7.363.097 2.042 1.564 10.015 4.923 7.363h.703l-1.407 6.024c2.1-2.215 10.777-10.023 7.017-13.46-3.22-2.943-4.87 5.967-4.907 7.436zm-5.38-47.91h-.704c-.13-3.835-1.625-6.29-5.627-7.363.097 2.042 1.564 10.015 4.923 7.363h.703l-1.407 6.024c2.1-2.215 10.777-10.023 7.017-13.46-3.22-2.943-4.87 5.967-4.907 7.436z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M299.51 210.84l-1.068-.118.074-.608c-.206.216-.438.37-.695.46a1.686 1.686 0 0 1-.75.09c-.5-.055-.904-.293-1.215-.715-.307-.424-.42-.98-.336-1.665.085-.7.324-1.214.715-1.54.39-.327.852-.462 1.38-.403.487.054.884.293 1.192.716l.252-2.057 1.15.13-.7 5.71zm-2.806-2.498c-.054.44-.03.768.075.98a.87.87 0 0 0 .724.514.876.876 0 0 0 .715-.245c.21-.194.343-.504.395-.93.058-.475.01-.827-.145-1.055a.866.866 0 0 0-.653-.392.9.9 0 0 0-.726.236c-.207.183-.336.48-.386.89zm-4.633-1.24l-1.02-.295c.165-.387.403-.66.713-.822s.747-.21 1.313-.146c.513.056.888.156 1.125.3.238.143.396.31.475.5.082.188.094.52.036.995l-.167 1.276c-.045.365-.06.636-.046.814.017.175.064.368.14.576l-1.137-.126a4.66 4.66 0 0 1-.072-.336c-.01-.067-.02-.11-.025-.133-.218.16-.445.273-.68.34-.235.066-.48.085-.734.057-.448-.05-.787-.205-1.018-.465-.23-.26-.32-.566-.278-.92.03-.233.113-.434.253-.603.14-.17.32-.293.542-.366.224-.075.54-.127.948-.156.55-.036.933-.084 1.15-.145l.014-.11c.026-.21-.01-.364-.108-.465-.1-.103-.3-.17-.602-.205-.205-.022-.37 0-.494.064-.123.064-.233.187-.327.372zm1.43 1.058c-.152.03-.392.06-.72.09-.327.03-.543.07-.65.122-.16.084-.253.205-.272.36a.518.518 0 0 0 .132.418.641.641 0 0 0 .438.218c.207.023.413-.02.618-.13a.717.717 0 0 0 .32-.33c.04-.09.076-.267.11-.53l.025-.218zm-2.933-2.505l-.107.873-.786-.087-.204 1.668c-.04.338-.06.536-.052.595.01.056.038.105.086.148.05.043.113.068.19.077.106.01.264-.006.475-.054l-.007.86c-.28.08-.59.1-.93.063a1.514 1.514 0 0 1-.548-.16.84.84 0 0 1-.337-.297 1.019 1.019 0 0 1-.108-.448c-.008-.13.01-.388.058-.775l.22-1.804-.527-.06.107-.87.528.057.1-.822 1.234-.51-.18 1.46.786.087zm-4.662 3.677l-1.15-.127.505-4.138 1.07.12-.073.587c.217-.258.403-.423.558-.495.16-.073.33-.1.516-.078.263.03.508.126.733.29l-.472.916c-.18-.14-.352-.22-.518-.24a.665.665 0 0 0-.425.084c-.122.07-.23.213-.322.426-.09.214-.178.673-.264 1.377l-.155 1.277zm-3.086-1.676l1.123.31a1.844 1.844 0 0 1-.812.838c-.34.173-.75.232-1.23.18-.755-.084-1.286-.38-1.59-.892-.242-.408-.327-.9-.257-1.473.084-.687.34-1.202.763-1.548.424-.348.924-.49 1.5-.426.647.072 1.132.332 1.456.782.325.446.427 1.088.31 1.925l-2.884-.32c-.032.326.03.59.185.79.156.2.366.314.63.344.18.02.338-.01.473-.09.133-.08.245-.22.333-.42zm.2-1.1c.03-.317-.026-.567-.17-.75a.804.804 0 0 0-.567-.314.83.83 0 0 0-.654.192c-.187.155-.296.383-.33.682l1.72.19zm-8.052 1.564l.7-5.71 1.15.127-.25 2.057c.4-.346.844-.49 1.33-.437.53.058.945.29 1.247.695.302.402.41.944.328 1.627-.087.706-.33 1.23-.732 1.573a1.713 1.713 0 0 1-2.07.173 1.76 1.76 0 0 1-.56-.595l-.073.61-1.068-.12zm1.407-2.03c-.052.427-.02.752.097.973.163.313.41.488.74.524a.839.839 0 0 0 .685-.236c.206-.187.336-.503.39-.947.058-.472.01-.823-.145-1.05a.868.868 0 0 0-.654-.393.899.899 0 0 0-.725.232c-.208.182-.337.48-.388.897zm-3.112-2.92l.124-1.014 1.15.128-.123 1.013-1.15-.128zm-.575 4.698l.506-4.138 1.15.128-.506 4.137-1.15-.127zm-5.08-.563l.692-5.665 1.212.134-.576 4.703 3.014.334-.118.963-4.225-.468z",
    fill: "#ecca5e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M201.08 254.06h-.704c-.13-3.835-1.625-6.29-5.627-7.363.097 2.042 1.564 10.015 4.923 7.363h.703l-1.407 6.024c2.1-2.215 10.777-10.023 7.017-13.46-3.22-2.943-4.87 5.967-4.907 7.436z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.94 232.795c0 .514-.583.93-1.303.93s-1.303-.416-1.303-.93c0-.513.583-.93 1.303-.93s1.304.417 1.304.93zm4.4-4.66c0 .514-.583.93-1.303.93s-1.303-.416-1.303-.93c0-.513.583-.93 1.303-.93s1.304.417 1.304.93zm4.07-4.34c0 .514-.583.93-1.303.93s-1.303-.416-1.303-.93c0-.513.583-.93 1.303-.93s1.304.417 1.304.93zm43.34-1.7c0 .514-.583.93-1.303.93s-1.303-.416-1.303-.93c0-.513.583-.93 1.303-.93s1.304.417 1.304.93zm3.09 6.04c0 .514-.583.93-1.303.93s-1.303-.416-1.303-.93c0-.513.583-.93 1.303-.93s1.304.417 1.304.93zm4.57 3.88c0 .514-.583.93-1.303.93s-1.303-.416-1.303-.93c0-.513.583-.93 1.303-.93s1.304.417 1.304.93z",
    fillRule: "evenodd",
    fill: "#fac349"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M262.6 199.3l-1.05-.19c.122-.402.33-.698.62-.89.29-.19.72-.282 1.288-.277.517.004.9.067 1.152.187.252.117.428.267.528.448.103.18.152.507.147.986l-.026 1.286c-.005.366.01.637.045.812.036.173.105.36.204.56l-1.147-.01a4.019 4.019 0 0 1-.108-.327 1.45 1.45 0 0 0-.04-.13c-.2.18-.412.316-.638.406-.226.09-.467.134-.723.132-.45-.004-.805-.124-1.064-.36a1.13 1.13 0 0 1-.378-.885 1.125 1.125 0 0 1 .683-1.044c.214-.098.523-.18.925-.25.542-.092.918-.18 1.128-.26v-.11c.004-.213-.05-.363-.16-.453-.11-.094-.316-.142-.62-.144-.206 0-.368.036-.484.113-.116.074-.21.207-.284.4zm1.54.908c-.148.046-.384.1-.706.163-.322.063-.533.125-.633.187-.15.1-.228.23-.23.386 0 .155.058.288.178.402a.66.66 0 0 0 .46.173c.21 0 .41-.062.6-.19.14-.1.234-.22.28-.363.03-.094.048-.273.05-.537l.003-.22zm-4.733-2.773l.01-1.02 1.16.012-.01 1.02-1.16-.012zm-.047 4.73l.04-4.165 1.16.01-.042 4.167-1.158-.012zm-2.177-.02l-1.158-.01.042-4.166 1.076.01-.006.59c.187-.277.353-.46.5-.547a.976.976 0 0 1 .504-.13c.265.004.518.075.76.216l-.367.956c-.194-.122-.375-.183-.542-.185-.162 0-.3.042-.413.127-.113.083-.204.235-.272.456-.066.222-.102.687-.11 1.396l-.012 1.285zm-1.87-4.182l-.008.878-.792-.006-.017 1.68c-.003.34 0 .538.015.595.017.054.05.1.103.138.054.037.12.056.197.056.107 0 .263-.033.467-.1l.09.855c-.27.106-.576.158-.917.155-.208 0-.396-.036-.563-.103a.878.878 0 0 1-.37-.262 1.049 1.049 0 0 1-.155-.433c-.023-.13-.033-.388-.03-.777l.02-1.816-.533-.004.007-.88.532.005.007-.827 1.17-.633-.016 1.47.793.008zm-5.85 1.217l-1.05-.19c.123-.4.33-.697.62-.888.29-.19.72-.284 1.29-.28.516.005.9.068 1.15.188.253.118.43.267.53.448.1.18.15.508.145.986l-.025 1.286c-.004.367.01.637.046.813.035.173.103.36.203.56l-1.146-.01a4.209 4.209 0 0 1-.108-.328l-.04-.13c-.2.182-.413.317-.64.406-.226.09-.467.134-.722.132-.45-.004-.806-.124-1.065-.36a1.134 1.134 0 0 1-.378-.885c.003-.235.063-.444.183-.626.12-.183.287-.323.5-.418.215-.097.523-.18.925-.25.543-.092.92-.18 1.128-.26l.002-.11c.003-.212-.05-.363-.16-.453-.11-.093-.316-.14-.62-.144-.207 0-.368.036-.485.113-.116.074-.21.208-.284.4zm1.54.91c-.148.044-.383.1-.705.16-.323.063-.533.126-.633.187-.152.1-.23.23-.23.387a.52.52 0 0 0 .177.4c.12.115.273.173.46.174.21 0 .408-.06.6-.19.14-.1.234-.22.28-.363.03-.094.047-.272.05-.537l.003-.22zm-8.057 1.926l.058-5.75 1.958.018c.742.007 1.225.04 1.45.1.345.09.633.28.864.572.23.29.344.664.34 1.12-.005.354-.075.65-.212.89s-.31.427-.52.564c-.208.134-.42.222-.634.265-.292.052-.714.075-1.266.07l-.796-.007-.02 2.17-1.222-.012zm1.27-4.766l-.018 1.632.668.006c.48.004.802-.023.965-.082s.29-.15.383-.28a.734.734 0 0 0 .145-.445.709.709 0 0 0-.19-.518.852.852 0 0 0-.487-.26c-.144-.027-.436-.043-.876-.047l-.59-.006zm2.404 110.66l-.8-.02c.04-.312.155-.555.346-.73.19-.174.497-.292.92-.353.382-.055.674-.052.876.007.2.06.35.15.446.272.1.12.176.36.233.714l.144.954c.044.272.09.47.136.597.05.125.123.255.222.39l-.85.124c-.03-.05-.07-.128-.12-.23-.023-.046-.038-.076-.047-.09-.125.156-.265.28-.422.373-.156.09-.33.152-.518.18-.334.047-.612 0-.833-.146a.859.859 0 0 1-.392-.61.849.849 0 0 1 .057-.485.821.821 0 0 1 .317-.368c.147-.096.365-.193.654-.29.39-.13.657-.238.802-.322l-.013-.08c-.025-.16-.083-.264-.175-.318-.092-.056-.252-.068-.478-.036a.644.644 0 0 0-.344.14.596.596 0 0 0-.16.33zm1.255.497c-.104.05-.272.118-.503.2-.23.083-.38.154-.444.21-.1.092-.14.196-.123.313.02.114.08.206.182.277.103.07.224.095.363.075a.765.765 0 0 0 .42-.21.495.495 0 0 0 .16-.3c.012-.072.002-.206-.03-.402l-.025-.163zm-2.552-.34l-.824.27a.596.596 0 0 0-.255-.337.612.612 0 0 0-.41-.065.652.652 0 0 0-.48.287c-.104.157-.13.4-.077.73.058.367.164.617.317.75.154.132.34.182.558.15a.59.59 0 0 0 .38-.19c.09-.102.14-.265.147-.487l.865.015c-.028.38-.152.683-.37.907-.22.224-.537.367-.955.427-.475.07-.877-.02-1.205-.263-.327-.243-.53-.617-.61-1.122-.083-.51-.004-.927.234-1.25.237-.327.597-.524 1.08-.594.395-.057.722-.02.98.108.26.127.468.35.622.666zm-4.783-.67l-.12-.757.86-.124.12.756-.86.124zm.56 3.507l-.493-3.09.86-.123.492 3.09-.86.124zm-1.74.25l-.68-4.262.86-.124.68 4.263-.86.125zm-3.86.56l-.68-4.264.86-.124.244 1.535c.22-.324.51-.513.873-.565.395-.057.744.032 1.047.268.302.234.494.606.575 1.116.083.526.016.95-.204 1.275a1.28 1.28 0 0 1-1.462.516 1.37 1.37 0 0 1-.528-.325l.073.453-.8.115zm.597-1.736c.05.32.14.55.272.688a.705.705 0 0 0 .644.24.614.614 0 0 0 .446-.3c.11-.175.138-.428.085-.76-.056-.352-.164-.596-.323-.732a.66.66 0 0 0-.554-.16.648.648 0 0 0-.477.303c-.112.17-.143.412-.093.72zm-2.246 1.974l-.073-.463a1.23 1.23 0 0 1-.406.457c-.175.123-.37.2-.584.23-.218.032-.42.015-.61-.052a.851.851 0 0 1-.436-.33c-.104-.153-.18-.375-.225-.666l-.312-1.955.86-.125.225 1.42c.07.434.127.7.174.793a.48.48 0 0 0 .21.208.578.578 0 0 0 .332.04.734.734 0 0 0 .377-.17.59.59 0 0 0 .193-.32c.025-.122 0-.403-.07-.845l-.207-1.303.86-.124.492 3.088-.797.116zm-6.477-2.224l.8-.115.073.454c.08-.17.2-.317.362-.44.16-.122.35-.2.566-.23.377-.055.72.04 1.027.283.31.243.503.615.583 1.117.083.516.014.937-.205 1.262-.22.322-.517.51-.894.566a1.2 1.2 0 0 1-.506-.03 1.788 1.788 0 0 1-.514-.284l.25 1.556-.86.124-.68-4.264zm1.088 1.37c.056.347.17.593.34.74a.7.7 0 0 0 .57.17.63.63 0 0 0 .46-.3c.11-.172.135-.43.08-.778-.052-.324-.158-.555-.32-.692a.667.667 0 0 0-.545-.162.664.664 0 0 0-.485.308c-.115.173-.147.41-.1.713zm-2.328.964l.878.013c-.063.314-.2.568-.414.76-.212.188-.496.31-.852.36-.565.082-1.01-.034-1.337-.345-.26-.25-.423-.59-.49-1.018-.083-.512-.007-.933.23-1.262.233-.332.566-.528.996-.59.483-.07.888.027 1.216.29.326.263.534.708.622 1.336l-2.152.31c.045.243.144.42.298.538.154.115.33.158.527.13a.536.536 0 0 0 .323-.155.645.645 0 0 0 .154-.368zm-.083-.833c-.045-.237-.138-.407-.28-.51a.611.611 0 0 0-.475-.123.61.61 0 0 0-.434.262c-.1.147-.132.332-.095.555l1.284-.186zm-6.152 2.74l-.68-4.264 1.903-.276c.48-.07.834-.08 1.062-.035.23.045.426.156.588.333.162.177.262.39.303.643.05.32-.006.6-.17.838-.165.236-.44.41-.824.52.212.08.392.177.54.288.15.112.357.317.626.618l.68.753-1.082.156-.802-.833c-.285-.298-.477-.484-.577-.557a.722.722 0 0 0-.3-.138 1.62 1.62 0 0 0-.463.017l-.183.026.283 1.78-.905.13zm.512-2.592l.67-.097c.433-.062.7-.118.804-.17a.482.482 0 0 0 .225-.216.55.55 0 0 0 .04-.333.511.511 0 0 0-.178-.328.578.578 0 0 0-.366-.12c-.075.002-.296.03-.663.082l-.706.102.173 1.08zm67.049.453l-.76-.24c.13-.286.315-.487.55-.602.236-.115.565-.145.987-.088.384.05.663.133.838.245.175.11.29.238.347.382.058.143.06.392.008.747l-.15.954c-.04.272-.056.474-.05.61.01.13.042.275.096.433l-.85-.112c-.016-.058-.03-.142-.05-.253-.006-.05-.01-.085-.015-.1a1.568 1.568 0 0 1-.515.242c-.178.046-.36.056-.55.03-.336-.044-.587-.165-.756-.364a.845.845 0 0 1-.192-.694.851.851 0 0 1 .614-.715 2.97 2.97 0 0 1 .714-.1c.413-.02.7-.05.866-.09l.012-.082c.023-.157 0-.274-.073-.35-.07-.08-.22-.135-.447-.165a.641.641 0 0 0-.37.04c-.094.045-.178.135-.253.272zm1.054.818c-.115.02-.296.038-.543.055-.244.017-.408.044-.488.08-.123.06-.194.15-.21.266a.385.385 0 0 0 .09.314.474.474 0 0 0 .325.17.775.775 0 0 0 .465-.085.528.528 0 0 0 .245-.245 1.55 1.55 0 0 0 .093-.394l.024-.162zm-2.886 1.13l-.86-.115.232-1.58c.05-.333.063-.55.04-.653a.441.441 0 0 0-.146-.254.52.52 0 0 0-.285-.122c-.15-.02-.29 0-.42.064a.603.603 0 0 0-.29.276c-.06.122-.118.356-.17.702l-.205 1.4-.86-.113.455-3.094.8.105-.068.454c.335-.312.718-.44 1.15-.382.19.025.358.082.505.17a.83.83 0 0 1 .32.294.876.876 0 0 1 .117.366c.014.132.003.318-.033.557l-.282 1.923zm-5.485-2.924l-.76-.24c.13-.286.315-.487.55-.602.236-.115.565-.145.987-.088.384.05.663.133.838.245.175.11.29.237.347.38.058.144.06.393.008.748l-.15.954c-.04.272-.057.475-.05.61.01.13.042.275.096.433l-.853-.113a3.203 3.203 0 0 1-.047-.253 1.036 1.036 0 0 0-.016-.1c-.167.115-.34.196-.516.24a1.409 1.409 0 0 1-.55.032c-.336-.045-.587-.166-.756-.365a.84.84 0 0 1-.19-.694.859.859 0 0 1 .613-.714c.17-.054.408-.087.714-.102.41-.018.7-.048.865-.09l.012-.08c.023-.158 0-.275-.073-.352-.07-.08-.22-.134-.447-.164a.648.648 0 0 0-.372.04c-.094.045-.177.136-.25.273zm1.054.818c-.116.02-.297.038-.543.055-.245.017-.41.044-.49.08-.122.06-.193.15-.21.266a.395.395 0 0 0 .09.315.48.48 0 0 0 .325.17.775.775 0 0 0 .465-.085.53.53 0 0 0 .245-.243c.033-.068.063-.2.092-.395l.024-.163zm-2.344-1.02l-.87.032a.561.561 0 0 0-.143-.39.596.596 0 0 0-.373-.175.676.676 0 0 0-.546.143c-.146.123-.244.35-.293.68-.054.367-.028.635.08.804.107.17.27.268.49.297a.612.612 0 0 0 .42-.078c.116-.075.212-.218.287-.428l.825.25c-.144.357-.353.614-.63.77-.276.154-.624.203-1.042.148-.476-.064-.834-.257-1.076-.58-.24-.323-.322-.738-.248-1.242.075-.51.275-.89.6-1.135.327-.25.732-.34 1.215-.276.395.053.698.176.907.37.21.193.342.462.396.808zm-4.38-1.945l.11-.757.86.114-.11.758-.86-.115zm-.52 3.514l.457-3.093.86.115-.455 3.093-.86-.114zm-.872-.116l-.86-.115.234-1.58c.05-.334.063-.552.04-.654a.44.44 0 0 0-.147-.254.508.508 0 0 0-.284-.12c-.15-.02-.29 0-.42.062s-.225.154-.29.276c-.06.123-.117.356-.168.702l-.207 1.402-.86-.115.456-3.095.8.107-.068.454c.335-.31.718-.44 1.15-.38.19.024.357.08.505.167a.847.847 0 0 1 .32.295.866.866 0 0 1 .117.367 2.37 2.37 0 0 1-.032.556l-.284 1.924zm-4.18-4.14l.112-.758.86.115-.112.76-.86-.116zm-.518 3.513l.456-3.093.86.114-.455 3.094-.86-.115zm-5.184-3.846l.793.107-.06.422c.33-.29.693-.41 1.085-.358.21.028.383.093.524.195.14.102.248.242.32.42.168-.146.34-.25.518-.308.177-.06.36-.078.548-.053.24.032.434.106.585.22a.846.846 0 0 1 .312.455c.04.14.038.358-.006.653l-.29 1.978-.862-.115.26-1.768c.046-.307.046-.51 0-.606-.062-.127-.176-.202-.342-.224a.615.615 0 0 0-.63.337c-.067.128-.122.338-.165.63l-.22 1.485-.86-.115.25-1.696c.045-.3.058-.496.04-.587a.358.358 0 0 0-.114-.214.439.439 0 0 0-.25-.1.658.658 0 0 0-.374.054.574.574 0 0 0-.274.264c-.064.122-.118.33-.16.628l-.223 1.504-.86-.115.455-3.094zm-4.186.975c.04-.27.15-.525.328-.76.178-.236.406-.404.682-.503.28-.1.578-.13.897-.086.49.065.872.272 1.14.618.27.345.37.75.303 1.214-.07.468-.286.835-.65 1.102-.36.264-.783.364-1.264.3-.3-.04-.575-.14-.827-.306-.25-.164-.43-.38-.533-.644-.104-.268-.13-.58-.078-.935zm.876.162c-.045.307-.003.552.125.736.13.183.306.29.53.32a.753.753 0 0 0 .6-.17c.177-.142.288-.37.334-.68.045-.303.003-.546-.126-.73a.73.73 0 0 0-.527-.32.761.761 0 0 0-.602.17c-.176.142-.287.367-.332.674zm-4.807-3.42l1.657.222c.374.05.655.114.843.195.252.11.458.27.618.484.16.212.27.462.327.75.058.284.057.627 0 1.026-.053.352-.143.65-.273.89a1.896 1.896 0 0 1-.592.69c-.18.126-.407.21-.687.258-.208.033-.48.027-.816-.017l-1.704-.228.63-4.272zm.8.845l-.416 2.828.677.09c.254.034.44.045.555.033a.84.84 0 0 0 .39-.13c.11-.07.21-.196.3-.378.09-.184.16-.44.207-.77.05-.33.055-.59.02-.774a.958.958 0 0 0-.196-.447.867.867 0 0 0-.39-.257c-.122-.044-.368-.09-.738-.14l-.407-.054z",
    fill: "#ecca5e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDo);
export default __webpack_public_path__ + "static/media/do.f03162b90a11d8c32c762c9d90d962e5.svg";
export { ForwardRef as ReactComponent };